<style lang="scss" scoped>
#create-sds-item-submission{
  background: rgb(245, 245, 245);

}
.sds-status{
  position: absolute;
  top:0;
  right:0;
  padding:0 15px;
  border-radius: 0 0 0 15px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: rgb(251, 229, 229);
  border: 1px solid #cccccc;
  background-color: #cccccc;
  color: #424242;
  
  &.submitted{
    border: 1px solid #00897B;
    background-color:#00897B;
    color: white;
  }
}
</style>
<template>
  <div id="create-sds-item-submission">
    <div class="page-control" style="padding-left:15px;padding-right:50px">
      <div class="page-control__left">
        <button class="button button--text button--action mr-2"  id="backUsulanList" @click="$router.back()">
            <VueFeather type="arrow-left" size="18" stroke-width="1.5" style="display:block"></VueFeather>
        </button>
        <b-popover target="backUsulanList" triggers="hover" placement="bottom">
          <template #title>Kembali ke halaman daftar usulan</template>
          Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik tombol draft atau submit, karena ketika kembali isian ada akan hilang
        </b-popover>
        <div class="my-1">
          <div style="font-family:'Manrope';font-weight:600;font-size:16px;color:#032F05;line-height:1">
            Buat {{form.submission_type == 'NEW' ? 'Usulan Baru':'Usulan Pemutakhiran'}}&nbsp;<span class="text-primary" >{{form.sds_type == 'INDICATOR' ? 'Indikator' : (form.sds_type == 'VARIABLE' ? 'Variabel' : (form.sds_type == 'CONCEPT' ? 'Konsep & Definisi' : ''))}}</span>
          </div>
          <div class="" style="font-family:'Manrope';font-weight:500;font-size:12px;color:#515151;">
            Harap baca panduan terlebih dahulu, agar pengusulan anda dapat menjadi lebih mudah.
          </div>
        </div>
      </div>
      <div class="page-control__center">
      </div>
      <div class="page-control__right">
        <button class="button mr-2" variant="outlined" size="sm" @click="save('DRAFT')">
          <VueFeather type="check" size="15" stroke-width="2.5" style="display:block;"></VueFeather>&nbsp;&nbsp;Draft
        </button>
        <button class="button" variant="primary" size="sm" @click="save('SUBMITTED')">
          <VueFeather type="send" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Submit
        </button>
      </div>
    </div>
    <b-row class="h-100p mx-0">
      <b-col class="form form--sm h-100p px-0">
        <div class="section">
          <div class="section__header">
            <div class="section__title d-flex">
              <div>
                <div class="section__title__name">{{section.currentIndex+1}}. {{section.items[section.currentIndex].name}}</div>
                <div class="section__title__description">{{section.items[section.currentIndex].description}}</div>
              </div>
            </div>

            <button class="ml-auto button" :class="updatedSdsnVisible ? 'active':''" variant="outlined" size="sm" @click="updatedSdsnVisible = !updatedSdsnVisible" v-if="form && form.submission_type == 'UPDATE'">
              <VueFeather type="info" size="16" stroke-width="2" style="display:block"></VueFeather> &nbsp; Info SDSN
            </button>
          </div>
          <div class="section__body">
            <b-tabs v-model="section.currentIndex" nav-class="d-none" content-class="px-0 py-0">
              <b-tab>
                <ValidationObserver ref="section1Observer">
                  <div class="mt-3 form">
                    <b-row >
                      <b-col v-if="isAdmin || isPembinaDataPusat">
                        <ValidationProvider name="Tahun Usulan" rules="required" v-slot="{errors}">
                          <b-form-group label="Tahun Usulan">
                            <Treeselect 
                              :clearable="false"
                              placeholder="Tahun Usulan"
                              v-model="form.submission_period"
                              :options="options.submissionPeriod"
                              :class="errors[0] ? 'invalid': (form.submission_period ? 'valid' : null)"
                            />
                            <b-form-invalid-feedback :state="false">{{errors[0]}}</b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col>
                        <ValidationProvider name="Provinsi" rules="required" v-slot="{errors}">
                          <b-form-group label="Provinsi">
                            <Treeselect 
                              clearable
                              placeholder="Provinsi"
                              v-model="provinceCode"
                              :options="options.province"
                              :normalizer="provinceNormalizer"
                              :disabled="true && !(isAdmin || isPembinaDataPusat)"
                              :class="errors[0] ? 'invalid': (provinceCode? 'valid' : null)"
                            />
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                        
                      </b-col>
                      <b-col>
                        <ValidationProvider name="Kabupaten/Kota" rules="required" v-slot="{errors}">
                          <b-form-group label="Kabupaten/Kota">
                            <Treeselect 
                              clearable
                              placeholder="Kabupaten/Kota"
                              v-model="cityCode"
                              :options="options.city"
                              :normalizer="cityNormalizer"
                              :disabled="true && !(isAdmin || isPembinaDataPusat)"
                              :class="errors[0] ? 'invalid': (cityCode? 'valid' : null)"
                            />
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <ValidationProvider name="Produsen Data" rules="required"  v-slot="{errors}">
                      <b-form-group label="Organisasi Pengusul">
                        <Treeselect 
                          clearable
                          valueFormat="object"
                          placeholder="Organisasi Pengusul bisa produsen data bisa walidata"
                          v-model="produsenData"
                          :class="errors[0] ? 'invalid': (produsenData? 'valid' : null)"
                          :async="true"
                          :options="options.produsenData"
                          :loadOptions="produsenDataLoadOptions"
                          :normalizer="produsenDataNormalizer"
                          @input="produsenDataChanged"
                          searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
                        />
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <b-table-simple class="table--stacked table--stacked--primary" v-if="produsenData">
                      <b-tbody>
                        <b-tr>
                            <b-th>Nama</b-th>
                            <b-td>{{produsenData.name}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="w-200 text-wrap">Singkatan</b-th>
                            <b-td>{{produsenData.details.abbreviation}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Provinsi</b-th>
                            <b-td>{{produsenData.details.province.name}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Kabupaten / Kota</b-th>
                            <b-td>{{produsenData.details.city.name}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Alamat</b-th>
                            <b-td>{{produsenData.details.address}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>No. Telepon</b-th>
                            <b-td>{{produsenData.details.phone}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Fax</b-th>
                            <b-td>{{produsenData.details.fax}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Email</b-th>
                            <b-td>{{produsenData.details.email}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Walidata</b-th>
                            <b-td>{{produsenData.details.walidata ? produsenData.details.walidata.name : '-'}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>  
                  </div>
                </ValidationObserver>
              </b-tab>
              <b-tab>
                <div class="mt-3 alert alert--warning align-items-start" v-if="!isSDNSPublished && submissionPeriod">
                  <div class="alert__icon pt-1 pr-1">
                    <VueFeather type="alert-triangle" size="24"></VueFeather>
                  </div>
                  <div class="alert__value">
                    <div class="text-13">
                      Usulan SDS untuk Periode Penetapan tahun {{submissionPeriod-1}} sedang dalam tahap pemeriksaan. Anda tetap dapat mengajukan usulan baru dan usulan pemutakhiran untuk periode {{submissionPeriod}} dengan memperhatikan beberapa hal berikut:
                    </div>
                    <ul style="padding-inline-start: 18px;" class="mb-0">
                      <li>Usulan SDS baru adalah usulan yang belum diusulkan pada periode {{submissionPeriod-1}} yang sedang diperiksa.</li>
                      <li>Penggusul harap memastikan terlebih dahulu usulan yang diusulkan tidak duplikat dengan usulan periode {{submissionPeriod-1}} dengan mencari pada <i>searchbox</i> dibawah ini.</li>
                    </ul>
                  </div>
                </div>
                <div v-if="isSDNSPublished">
                  <div class="table-search">
                    <b-input-group>
                      <b-input-group-prepend is-text class="bg-none">
                        <VueFeather type="key" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                      </b-input-group-prepend>
                      <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="filterIdSdsValue" 
                        placeholder="Kode SDSN" 
                        class="border-left-0"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <VueFeather type="bar-chart" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                      </b-input-group-prepend>
                      <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="filterIndicatorNoValue" 
                        placeholder="No. Indikator" 
                        class="border-left-0"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <VueFeather type="type" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                      </b-input-group-prepend>
                      <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="filterConceptValue" 
                        placeholder="Konsep" 
                        class="border-left-0"></b-form-input>
                    </b-input-group>
                    <div class="d-flex align-items-center ml-5">
                      <label class="text-nowrap m-0 mr-1">Jumlah baris:</label>
                      <b-form-select v-model="pagination.pageSize" :options="options.page" size="sm" @change="getSdsnList"></b-form-select>
                    </div>
                  </div>
                  <div class="table-wrapper mt-2 shadow">
                    <b-table
                      class="table--light"
                      show-empty
                      :items="sdsn"
                      :fields="fields"
                    >
                      <template #cell(no)="data">
                        {{ startRowNumber + data.index}}
                      </template>
                      <template #head(idSds)="data">
                        <div class="d-flex align-items-center">
                          <div>{{data.label}}</div>
                          <div class="ml-1">
                            <b-button  type="button"  class="button button--action" v-show="sortBy[0].direction == null" @click="sortSdsn(sortBy[0])">
                                <b-icon icon="chevron-expand"></b-icon>
                            </b-button>
                            <b-button  type="button"  class="button button--action" v-show="sortBy[0].direction == 'asc'" @click="sortSdsn(sortBy[0])">
                                <b-icon icon="sort-alpha-down"></b-icon>
                            </b-button>
                            <b-button  type="button"  class="button button--action" v-show="sortBy[0].direction == 'desc'"  @click="sortSdsn(sortBy[0])">
                                <b-icon icon="sort-alpha-up"></b-icon>
                            </b-button>
                          </div>
                        </div>
                      </template>
                      <template #head(noIndikator)="data">
                        <div class="d-flex align-items-center">
                          <div>{{data.label}}</div>
                          <div class="ml-1">
                            <b-button  type="button"  class="button button--action" v-show="sortBy[1].direction == null" @click="sortSdsn(sortBy[1])">
                                <b-icon icon="chevron-expand"></b-icon>
                            </b-button>
                            <b-button  type="button"  class="button button--action" v-show="sortBy[1].direction == 'asc'" @click="sortSdsn(sortBy[1])">
                                <b-icon icon="sort-alpha-down"></b-icon>
                            </b-button>
                            <b-button  type="button"  class="button button--action" v-show="sortBy[1].direction == 'desc'"  @click="sortSdsn(sortBy[1])">
                                <b-icon icon="sort-alpha-up"></b-icon>
                            </b-button>
                          </div>
                        </div>
                      </template>
                      <template #head(konsep)="data">
                        <div class="d-flex align-items-center">
                          <div>{{data.label}}</div>
                          <div class="ml-1">
                            <b-button  type="button"  class="button button--action" v-show="sortBy[2].direction == null" @click="sortSdsn(sortBy[2])">
                                <b-icon icon="chevron-expand"></b-icon>
                            </b-button>
                            <b-button  type="button"  class="button button--action" v-show="sortBy[2].direction == 'asc'" @click="sortSdsn(sortBy[2])">
                                <b-icon icon="sort-alpha-down"></b-icon>
                            </b-button>
                            <b-button  type="button"  class="button button--action" v-show="sortBy[2].direction == 'desc'"  @click="sortSdsn(sortBy[2])">
                                <b-icon icon="sort-alpha-up"></b-icon>
                            </b-button>
                          </div>
                        </div>
                      </template>
                      <template #cell(action)="data">
                        <div class="d-flex justify-content-center">
                          <b-button 
                            type="button" 
                            class="button button--action button--action--edit" 
                            @click="updateSds(data.item)"
                          >
                            <VueFeather type="edit-3" size="14"></VueFeather>
                          </b-button>
                        </div>
                      </template>

                      <template #empty>
                        <div class="table__empty">
                          <div v-if="table.isLoading">
                            <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                          <div v-else class="d-flex flex-column">
                            <div>
                              Tidak ada data yang tersedia
                            </div>
                            <div class="i-text-13">
                              Anda dapat mengusulkan SDS Baru dengan melakukan click tombol dibawah ini
                            </div>
                            <div class="mt-2">
                              <b-button type="button" class="button button--primary" @click="createSds()" >Usul Baru</b-button>
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-table>
                    <b-pagination
                      class="mt-3"
                      v-model="pagination.currentPage"
                      :total-rows="pagination.totalElements"
                      :per-page="pagination.pageSize"
                      align="center"
                      @input="handlePageChange"
                      v-if="pagination.totalElements>0 && isLoading == false"
                    ></b-pagination>
                  </div>
                </div>
                <div v-else>
                  <div class="table-search">
                    <b-input-group>
                      <b-input-group-prepend is-text class="bg-none">
                        <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                      </b-input-group-prepend>
                      <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="formFilter.name" 
                        placeholder="Cari nama usulan konsep, variabel dan indikator . . ." 
                        class="border-left-0"></b-form-input>
                    </b-input-group>
                  </div>
                  <div class="table-wrapper" style="margin-top:15px">
                    <b-table class="table--light" :items="table.items" :fields="table.fields" show-empty> 
                      <template #cell(no)="data">
                        {{ (table.pagination.totalElements == 0 ? '0' : (table.pagination.currentPage-1)*table.pagination.pageSize+1)  + data.index }}
                      </template>
                      <template #cell(submission_type)="data">
                        {{ data.value == 'NEW' ? 'Baru':'Pemutakhiran'}} 
                      </template>
                      <template #cell(sds_type)="data">
                        {{ data.value == 'CONCEPT' ? 'Konsep':(data.value == 'VARIABLE' ? 'Variabel':'Indikator')}}
                      </template>
                      <template #cell(created_at)="data">
                        {{dateFormatter(data.value)}}
                      </template>
                      <template #cell(status)="data">
                        <div :class="'status status--'+statusFormatterStyle(data.value)">
                          {{statusFormatter(data.value)}}
                        </div>
                      </template>
                      <template #cell(action)="data">
                        <div class="d-flex justify-content-center">
                          <b-link  
                            class="button button--action button--action--view " v-b-tooltip.hover title="Lihat detail"  target="_blank" 
                            :href="data.item.submission_period==2022 ? '/old-sds/lihat-detail-usulan/'+data.item.id : '/old-sds/v2/lihat-detail-usulan/'+data.item.id"
                          >
                            <VueFeather type="eye" size="14"></VueFeather>
                          </b-link>
                        </div>
                      </template>
                      <template #empty>
                        <div class="table__empty">
                          <div v-if="table.isLoading">
                            <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                          <div v-else class="flex-column">
                            <div>
                              Tidak ada data yang tersedia
                            </div>
                            <div class="i-text-13">
                              Anda dapat mengusulkan SDS Baru dengan melakukan klik pada tombol dibawah ini
                            </div>
                            <div class="mt-2">
                              <b-button type="button" class="button button--sm button--primary" @click="createSds()" >Usul Baru</b-button>
                            </div>
                          </div>
                        </div>
                      </template> 
                    </b-table>
                    <b-pagination
                      class="mt-3 "
                      align="center"
                      v-if="table.pagination.totalElements >0 && isLoading == false"
                      v-model="table.pagination.currentPage"
                      :total-rows="table.pagination.totalElements"
                      :per-page="table.pagination.pageSize"
                      @input="filterSdsItemList"
                    ></b-pagination>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <b-form @submit.stop.prevent ref="usulanSdsForm" class="mt-3 form form--sm">
                  <div class="border-bottom mb-4">
                    <ValidationObserver ref="sdsTypeObserver">
                      <ValidationProvider name="Jenis Standar Data Statistik" rules="required" v-slot="{errors}">
                        <b-form-group label="Jenis Standar Data Statistik">
                          <b-form-radio-group 
                            v-model="form.sds_type" 
                            :options="options.sds_type"
                            :state="errors[0] ? false: (form.sds_type ? true : null)"
                          >
                          </b-form-radio-group>
                          <b-form-invalid-feedback :state="false">{{errors[0]}}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </ValidationObserver>
                  </div>

                  <ValidationObserver ref="conceptObserver" v-if="form.sds_type == 'CONCEPT'">
                    <ValidationProvider name="Nama Konsep"  rules="required" v-slot="{errors}">
                      <b-form-group label="Nama Konsep">
                        <b-form-input 
                          v-model="concept.name" 
                          placeholder="Nama konsep"
                          :state="errors[0] ? false: (concept.name ? true : null)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="Definsi Konsep"  rules="required" v-slot="{errors}">
                      <b-form-group label="Definsi">
                        <b-form-textarea 
                          rows="3"
                          v-model="concept.definition" 
                          placeholder="Tuliskan secara jelas definisi konsep dan batasannya" 
                          :state="errors[0] ? false: (concept.definition ? true : null)"
                        >
                        </b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <ValidationObserver ref="conceptReferencesObserver">
                      <b-form-group label="Sumber referensi yang digunakan">
                        <b-table-simple class="table--form">
                          <b-tbody >
                            <b-tr v-for="(item,index) in concept.references" :key="index">
                              <b-td class="w-40">
                                <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                              </b-td>
                              <b-td>
                                <ValidationProvider :name="'Sumber referensi ke-'+(index+1)" rules="required" v-slot="{errors}">
                                  <b-form-input 
                                    size="sm"
                                    type="search"
                                    placeholder="Tuliskan sumber referensi dari konsep yang diusulkan"
                                    v-model="concept.references[index]"
                                    :state="errors[0] ? false: (item ? true : null)"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </b-td>
                              <td class="w-34 pl-0">
                                <b-button 
                                  class="button button--action button--action--delete2" 
                                  v-on:click="deleteConceptReference(index)" 
                                  :disabled="concept.references.length==1? true: false"
                                >
                                  <VueFeather type="x" size="14"></VueFeather>
                                </b-button>
                              </td>
                            </b-tr>
                            <tr>
                              <td class="my-0 text-600 v-align-center" colspan="2">Jika Referensi Lebih dari satu bisa melakukan klik tombol tambah</td>
                              <td class="my-0">
                                <b-button  class="button button--action button--action--view2" @click="addConceptReference">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                              </td>
                            </tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-form-group>
                    </ValidationObserver>
                  </ValidationObserver>

                  <ValidationObserver ref="variableObserver" v-if="form.sds_type == 'VARIABLE'">
                    <ValidationProvider name="Nama Variabel"  rules="required" v-slot="{errors}">
                      <b-form-group label="Nama Variabel">
                        <b-form-input 
                          v-model="variable.name" 
                          placeholder="Nama Variabel"
                          :state="errors[0] ? false: (variable.name ? true : null)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="Definsi Variabel"  rules="required" v-slot="{errors}">
                      <b-form-group label="Definsi">
                        <b-form-textarea 
                          rows="3"
                          v-model="variable.definition" 
                          placeholder="Tuliskan secara jelas definisi variabel dan batasannya" 
                          :state="errors[0] ? false: (variable.definition ? true : null)"
                        >
                        </b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <b-form-group label="Konsep">
                      <div class="py-3 px-4 mb-2 i-shadow border" >
                        <ValidationProvider name="Konsep variabel" rules="required" v-slot="{errors}">
                          <b-form-group label="Pilih konsep">
                            <Treeselect 
                              placeholder="Pilih konsep yang digunakan"
                              clearable
                              valueFormat="object"
                              v-model="variableConcepts" 
                              :class="errors[0] ? 'invalid': (variableConcepts && variableConcepts.length>0 ? 'valid' : null)"
                              :multiple="true" 
                              :async="true"
                              :options="options.concept"
                              :loadOptions="conceptReferenceLoadOptions"
                              :normalizer="conceptNormalizer"
                              @input="variableConceptsChanged"
                            >
                            <div slot="option-label" slot-scope="{node}" class="border-bottom">
                              <div style="position:relative;padding: 4px 8px;">
                                <div style="white-space:initial;line-height:normal;color:#383838">
                                  {{ node.raw.name}}
                                </div>
                                <div style="white-space:initial;line-height:normal; font-size:10px !important">
                                  {{ node.raw.data.concept.definition}}
                                </div>
                                <div class="d-flex" style="margin:8px 0 10px 0">
                                  <div 
                                    style="padding:2px 5px;height:20px;font-weight:500;font-size:11px" 
                                    :class="'d-flex align-items-center justify-content-center status status--'+statusFormatterStyle(node.raw.status)"
                                  >{{statusFormatter(node.raw.status)}}</div>
                                  <div v-if="node.raw.produsen_data_name"
                                    style="border: 1px solid #dedede;padding:2px 5px;height:20px;font-weight:500;background:#ffffff" 
                                    class="ml-1 text-11 d-flex align-items-center justify-content-center status status--draft">
                                    {{ node.raw.produsen_data_name}}
                                  </div>
                                </div>                         
                              </div>
                            </div>
                            </Treeselect>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                        <div class="item__field-value"  >
                          <div class="table-wrapper">
                            <b-table-simple class="table table--light table--bordered" >
                              <b-thead>
                                <tr>
                                  <th class="text-center w-30">No</th>
                                  <th class="text-left w-min-150">Nama</th>
                                  <th class="text-left w-100">Definisi</th>
                                  <th class="text-center w-80">Status</th>
                                  <th class="text-center w-auto">Detail</th>
                                </tr>
                              </b-thead>
                              <b-tbody >
                                <b-tr v-for="(item,index) in variableConcepts" :key="index">
                                  <b-td class="text-center w-auto">{{index+1}}</b-td>
                                  <b-td class="text-left">{{item.name}}</b-td>
                                  <b-td class="text-left">{{item.data.concept.definition}}</b-td>
                                  <b-td class="text-center w-auto text-nowrap">
                                    <div :class="'status status--'+statusFormatterStyle(item.status)" >
                                      {{statusFormatter(item.status)}}
                                    </div>
                                  </b-td>
                                  <b-td>
                                    <div class="d-flex justify-content-center">
                                      <b-button v-if="isRejected(item.status)" type="button" class="button button--action button--action--delete"  @click="showConceptReference(item.id)">
                                        <VueFeather type="repeat" size="16" stroke-width="2"></VueFeather>
                                      </b-button>
                                      <b-button v-else type="button" class="button button--action button--action--view"  @click="showConceptReference(item.id)"  >
                                        <VueFeather type="eye" size="16" stroke-width="2" ></VueFeather>
                                      </b-button>
                                    </div>
                                  </b-td>
                                </b-tr>
                                <b-tr v-if="variableConcepts.length==0">
                                  <b-td class="text-danger text-center" colspan="6">
                                    <div class="d-flex align-items-center justify-content-center py-1">
                                      <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Tidak konsep yang digunakan
                                    </div>
                                  </b-td>
                                </b-tr>
                              </b-tbody>
                            </b-table-simple>
                          </div>
                        </div>
                      </div>
                    </b-form-group>

                    <ValidationProvider name="Unit Observasi" rules="required" v-slot="{errors}">
                      <b-form-group label="Unit Observasi" description="Tuliskan unit observasi dimana variabel merupakan salah satu dari karakteristik unit observasi tersebut">
                        <multiselect 
                          tag-placeholder="Tambahkan unit observasi baru" 
                          placeholder="Pilih atau tambahkan unit observasi" 
                          selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                          label="name"  track-by="name" 
                          v-model="variable.unit_types" 
                          :options="options.unit_type" 
                          :multiple="true" 
                          :taggable="true" 
                          :class="errors[0] ? 'invalid': ( variable.unit_types.length>0 ? 'valid':'')"
                          @tag="addNewUnitType">
                          <template slot="option" slot-scope="props">
                            <input 
                              class="ml-2"
                              type="checkbox" 
                              :name="props.option.name ?  props.option.name: props.search" 
                              :checked="itemExist(props.option.name, variable.unit_types)">
                            <label for="vehicle3" class="pl-2 m-0 text-13">
                              {{ props.option.name ?  props.option.name: props.search  }}
                            </label>
                          </template>
                        </multiselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Ukuran Variabel"  v-slot="{errors}">
                      <b-form-group label="Ukuran" description="Kosongkan jika tidak ada">
                        <multiselect 
                          tag-placeholder="Tambahkan ukuran baru" 
                          placeholder="Pilih atau tambahkan ukuran" 
                          selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                          label="name"  track-by="name" 
                          v-model="variable.measurement" 
                          :options="measurements" 
                          :taggable="true" 
                          :class="errors[0] ? 'invalid': ( variable.measurement ? 'valid':'')"
                          @input="variable.measurement_unit = null"
                          @tag="addNewVariableMeasurement">
                        </multiselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Satuan Variabel" :rules="variable.measurement ? 'required':''" v-slot="{errors}">
                      <b-form-group label="Satuan" description="Kosongkan jika tidak ada ukuran variabel">
                        <multiselect 
                          tag-placeholder="Tambahkan satuan baru untuk ukuran yang digunakan" 
                          placeholder="Pilih atau tambahkan satuan" 
                          selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                          label="name"  track-by="name" 
                          v-model="variable.measurement_unit" 
                          :options="variableMeasurementUnits" 
                          :taggable="true" 
                          :class="errors[0] ? 'invalid': ( variable.measurement_unit ? 'valid':'')"
                          @tag="addNewVariableMeasurementUnit">
                        </multiselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    
                    <ValidationProvider name="Subyek variabel" rules="required" v-slot="{errors}">
                      <b-form-group ref="subyekVariable" label="Subyek" description="Pilih subyek yang cocok dengan variabel">
                        <Treeselect 
                          clearable
                          valueFormat="object"
                          placeholder="Pilih subyek"
                          v-model="variable.subject_field"
                          :disable-branch-nodes="true"
                          :normalizer="normalizer"
                          :class="errors[0] ? 'invalid': (variable.subject_field ? 'valid' : null)"
                          :options="options.subject_fields"
                          :loadOptions="loadOptions"
                        >
                          <div slot="option-label" slot-scope="{node}" class="d-flex">
                            <div :style="node.raw.code.length==1 ? 'width:20px':(node.raw.code.length<=4 ? 'width:32px':'width:45px' )">{{node.raw.code}}.</div>
                            <div>{{node.raw.name}}</div>
                          </div>
                        </Treeselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Jenis Value Domain"  rules="required" v-slot="{errors}">
                      <b-form-group label="Jenis Value Domain" description="">
                        <b-form-radio-group 
                          v-model="variable.value_domain.type" 
                          :state="errors[0] ? false: (variable.value_domain.type? true : null)"
                          :options="options.value_domain_type"
                          :class="errors ? 'invalid':'valid'"
                          @input="valueDomainTypeChanged"
                        ></b-form-radio-group>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <div class="border m-0 i-shadow bg-white mb-4" v-if="variable.value_domain.type && variable.value_domain.type.id==76 ">
                      <div class="border-bottom px-4 py-3" style="background:#f3f3f3;">
                        <div class="text-13 text-bold border-bottom pb-1">Value domain (Klasifikasi)</div>
                        <div class="text-12 pt-1">
                          Value domain adalah rentang nilai dari isian variabel yang diperboleh. 
                          Isian value domain yang terlalu banyak seperti kode master wilayah atau KBLI tidak perlu
                          diisikan itemnya satu persatu. <span class="text-danger">Contoh: Jika Variabelnya adalah jenis kelamin maka item value domainnya 
                          adalah (1). Laki-laki dan (2). Perempuan </span>
                        </div>
                      </div>
                      <div class="px-4 py-3">
                        <b-form-group label="Pilih Klasifikasi yang digunakan sebagai referensi value domain">
                          <b-form-radio-group stacked
                            v-model="classificationReferenceId"
                            :options="options.classification_series"
                            @input="(value)=>{
                              variable.value_domain.items=[];
                              if(value){
                                let classSeries = this.options.classification_series.find(x=>x.id == value);
                                variable.value_domain.classification_reference.id = classSeries.id;
                                variable.value_domain.classification_reference.name = classSeries.name;
                                variable.value_domain.classification_reference.description = classSeries.description;
                                classificationReferenceUsedType= 'FULL'
                              }else{
                                variable.value_domain.classification_reference = null;
                                variable.value_domain.items.push({
                                  id: null,
                                  code: null,
                                  name: null,
                                  description: null,
                                  parent_code: null,
                                  level: null,
                                });
                              }  
                            }"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-group label="Jenis penggunaan item klasifikasi" v-if="classificationReferenceId">
                          <b-form-radio-group stacked
                            v-model="classificationReferenceUsedType"
                            @input="(value)=>{
                              variable.value_domain.classification_reference.used_type = value;
                              variable.value_domain.items=[];
                            }"
                          >
                            <b-form-radio value="FULL">Semua kode digunakan</b-form-radio>
                            <b-form-radio value="PARTIAL">Hanya sebagian kode yang digunakan</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                      <!-- {{variable.value_domain.classification_reference.used_type=='PARTIAL'}} -->
                      <div class="px-4 pt-3 border-top" 
                        v-if="variable.value_domain.type && 
                              variable.value_domain.type.id==76 && 
                              (classificationReferenceId ==null || (classificationReferenceId && classificationReferenceUsedType=='PARTIAL'))"
                      >
                        <ValidationObserver ref="valueDomainItemsObserver">
                          <b-form-group label="Daftar item value domain" class="mb-4">
                            <div class="table-wrapper">
                              <b-table-simple class="table--light table--bordered" :class="classificationReferenceId !=null && classificationReferenceUsedType=='PARTIAL' ? '' : 'table--form'">
                                <b-thead>
                                  <tr>
                                    <th class="text-center w-45">No</th>
                                    <th class="text-left w-150">Kode</th>
                                    <th class="text-left">Nama</th>
                                    <th class="text-left">Deskripsi</th>
                                    <th class="text-center">Hapus</th>
                                  </tr>
                                </b-thead>
                                <b-tbody v-if="classificationReferenceId==null">
                                  <b-tr v-for="(item,index) in variable.value_domain.items" :key="index">
                                    <b-td>
                                      <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                                    </b-td>
                                    <b-td>
                                      <ValidationProvider :name="'Kode Item ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                        <b-form-input 
                                          size="sm"
                                          :state="errors[0] ? false: (item.code ? true : null)"
                                          v-model="item.code" 
                                          placeholder="Contoh : L , P" ></b-form-input>
                                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                      </ValidationProvider>
                                    </b-td>
                                    <b-td>
                                      <ValidationProvider :name="'Nama Item ke-'+(index+1)" rules="required" v-slot="{errors}">
                                          <b-form-input 
                                            size="sm"
                                            :state="errors[0] ? false: (item.name ? true : null)"
                                            v-model="item.name" 
                                            placeholder="Contoh : Laki-laki , Perempuan" ></b-form-input>
                                          <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-td>
                                    <b-td>
                                      <b-form-input  
                                        size="sm" 
                                        v-model="item.description"  
                                        placeholder="Contoh : Laki-laki adalah ..." >
                                      </b-form-input>   
                                    </b-td>
                                    <td class="w-34">
                                      <div class="d-flex justify-content-center">
                                        <b-button 
                                          class="button button--action button--action--delete2"
                                          v-on:click="deleteVariableValueDomain(index)" 
                                          :disabled="variable.value_domain.items.length==1"
                                        >
                                          <VueFeather type="x" size="16"></VueFeather>
                                        </b-button>
                                      </div>
                                    </td>
                                  </b-tr>
                                </b-tbody>

                                <b-tbody v-if="classificationReferenceUsedType=='PARTIAL'">
                                  <b-tr v-for="(item,index) in variable.value_domain.items" :key="index">
                                    <b-td class="text-center">{{index+1}}</b-td>
                                    <b-td>{{item.code}}</b-td>
                                    <b-td>{{item.name}}</b-td>
                                    <b-td>{{item.description}}</b-td>
                                    <td class="w-34">
                                      <div class="d-flex justify-content-center">
                                        <b-button 
                                          class="button button--action button--action--delete2"
                                          v-on:click="deleteVariableValueDomain(index)" 
                                          :disabled="variable.value_domain.items.length==1"
                                        >
                                          <VueFeather type="x" size="16"></VueFeather>
                                        </b-button>
                                      </div>
                                    </td>
                                  </b-tr>
                                  <b-tr v-if="variable.value_domain.items.length==0">
                                    <b-td class="text-danger text-center" colspan="6">
                                      <div class="d-flex align-items-center justify-content-center py-1">
                                        <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Item Value Domain tidak boleh kosong
                                      </div>
                                    </b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                              <div class="pagination-wrapper d-block" style="padding: 7px 9px">
                                <div class="d-flex align-items-center">
                                  <div class="flex-grow-1 text-600 text-13">
                                    Jika Isian Klasifikasi Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button class="button button--action button--action--view2" v-if="classificationReferenceId==null"
                                    @click="addNewVariableValueDomain" 
                                  >
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                  <b-button class="button button--action button--action--view2" 
                                    v-if="classificationReferenceId !=null && classificationReferenceUsedType=='PARTIAL'"
                                    @click="showModalValueDomain(classificationReferenceId)" 
                                  >
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                              </div>
                            </div>
                            
                          </b-form-group>
                        </ValidationObserver>
                      </div>
                      <!-- <div class="d-flex justify-content-end mx-4 py-2" v-if="variable.value_domain.classification_reference==null">
                        <b-button class="button button--primary" 
                          v-on:click="addNewVariableValueDomain" >Tambah item
                        </b-button>
                      </div>
                      <div class="d-flex justify-content-end mx-4 py-2" v-if="variable.value_domain.classification_reference !=null && classificationReferenceUsedType=='PARTIAL'">
                        <b-button class="button button--primary" 
                          v-on:click="showModalValueDomain(variable.value_domain.classification_reference.id)" >Tambah item
                        </b-button>
                      </div> -->
                    </div>

                    <ValidationProvider name="Aturan Validasi" v-slot="{errors}">
                      <b-form-group label="Aturan Validasi">
                        <b-form-textarea 
                          rows="3"
                          v-model="variable.rule" 
                          placeholder="Deskripsikan aturan validasi yang dimiliki variabel" 
                          :state="errors[0] ? false: (variable.rule ? true : null)"
                        >
                        </b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationObserver ref="variableReferencesObserver">
                      <b-form-group label="Sumber referensi yang digunakan">
                        <b-table-simple class="table--form">
                          <b-tbody >
                            <b-tr v-for="(item,index) in variable.references" :key="index">
                              <b-td class="w-40">
                                <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                              </b-td>
                              <b-td>
                                <ValidationProvider :name="'Sumber referensi ke-'+(index+1)" rules="required" v-slot="{errors}">
                                  <b-form-input 
                                    type="search"
                                    placeholder="Tuliskan sumber referensi dari variabel yang diusulkan"
                                    v-model="variable.references[index]"
                                    :state="errors[0] ? false: (item ? true : null)"
                                    size="sm"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </b-td>
                              <td class="w-34">
                                <b-button 
                                  class="button button--action button--action--delete2" 
                                  v-on:click="deleteVariableReference(index)" 
                                  :disabled="variable.references.length==1? true: false"
                                >
                                  <VueFeather type="x" size="14"></VueFeather>
                                </b-button>
                              </td>
                            </b-tr>
                            <tr>
                              <td class="my-0 text-600 v-align-center" colspan="2">Jika Referensi Lebih dari satu bisa melakukan klik tombol tambah</td>
                              <td class="my-0">
                                <b-button  class="button button--action button--action--view2" @click="addVariableReference">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                              </td>
                            </tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-form-group>
                    </ValidationObserver>
                  </ValidationObserver>
                  
                  <ValidationObserver ref="indicatorObserver" v-if="form.sds_type == 'INDICATOR'">
                    <ValidationProvider name="Nama Indikator"  rules="required" v-slot="{errors}">
                      <b-form-group label="Nama Indikator">
                        <b-form-input 
                          v-model="indicator.name" 
                          placeholder="Nama Indikator"
                          :state="errors[0] ? false: (indicator.name ? true : null)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="Definsi Indikator"  rules="required" v-slot="{errors}">
                      <b-form-group label="Definsi">
                        <b-form-textarea 
                          rows="3"
                          v-model="indicator.definition" 
                          placeholder="Tuliskan secara jelas definisi Indikator dan batasannya" 
                          :state="errors[0] ? false: (indicator.definition ? true : null)"
                        >
                        </b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <b-form-group label="Konsep">
                      <div class="py-3 px-4 mb-2 i-shadow border" >
                        <ValidationProvider name="Konsep indikator" rules="required" v-slot="{errors}">
                          <b-form-group label="Pilih konsep">
                            <Treeselect 
                              placeholder="Pilih konsep yang digunakan"
                              clearable
                              valueFormat="object"
                              v-model="indicatorConcepts" 
                              :class="errors[0] ? 'invalid': (indicatorConcepts.length>0 ? 'valid' : null)"
                              :async="true"
                              :multiple="true" 
                              :options="options.concept"
                              :loadOptions="conceptReferenceLoadOptions"
                              :normalizer="conceptNormalizer"
                              @input="indicatorConceptsChanged"
                            >
                            <div slot="option-label" slot-scope="{node}" class="border-bottom">
                              <div style="position:relative;padding: 4px 8px;">
                                <div style="white-space:initial;line-height:normal;color:#383838">
                                  {{ node.raw.name}}
                                </div>
                                <div style="white-space:initial;line-height:normal; font-size:10px !important">
                                  {{ node.raw.data.concept.definition}}
                                </div>
                                <div class="d-flex" style="margin:8px 0 10px 0">
                                  <div 
                                    style="padding:2px 5px;height:20px;font-weight:500;font-size:11px" 
                                    :class="'d-flex align-items-center justify-content-center status status--'+statusFormatterStyle(node.raw.status)"
                                  >{{statusFormatter(node.raw.status)}}</div>
                                  <div v-if="node.raw.produsen_data_name"
                                    style="border: 1px solid #dedede;padding:2px 5px;height:20px;font-weight:500;background:#ffffff" 
                                    class="ml-1 text-11 d-flex align-items-center justify-content-center status status--draft">
                                    {{ node.raw.produsen_data_name}}
                                  </div>
                                </div>                            
                              </div>
                            </div>
                            </Treeselect>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                        
                        <div class="table-wrapper">
                          <b-table-simple class="table table--light table--bordered" >
                            <b-thead>
                              <tr>
                                <th class="text-center w-30">No</th>
                                <th class="text-left w-min-150">Nama</th>
                                <th class="text-left w-100">Definisi</th>
                                <th class="text-center w-80">Status</th>
                                <th class="text-center w-auto">Detail</th>
                              </tr>
                            </b-thead>
                            <b-tbody >
                              <b-tr v-for="(item,index) in indicatorConcepts" :key="index">
                                <b-td class="text-center w-auto">{{index+1}}</b-td>
                                <b-td class="text-left">{{item.name}}</b-td>
                                <b-td class="text-left">{{item.data.concept.definition}}</b-td>
                                <b-td class="text-center w-auto text-nowrap">
                                  <div :class="'status status--'+statusFormatterStyle(item.status)" >
                                    {{statusFormatter(item.status)}}
                                  </div>
                                </b-td>
                                <b-td class="text-center w-auto">
                                  <b-button v-if="isRejected(item.status)" type="button" class="button button--action button--action--delete" style="margin-left:2px"  @click="showConceptReference(item.id)">
                                    <VueFeather type="repeat" size="16" stroke-width="2"></VueFeather>
                                  </b-button>
                                  <b-button v-else type="button" class="button button--action button--action--view"  @click="showConceptReference(item.id)" style="margin-left:2px"  >
                                    <VueFeather type="eye" size="16" stroke-width="2" ></VueFeather>
                                  </b-button>
                                </b-td>
                              </b-tr>

                              <b-tr v-if="indicatorConcepts.length==0">
                                <b-td class="text-danger text-center" colspan="6">
                                  <div class="d-flex align-items-center justify-content-center py-1">
                                    <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Tidak konsep yang digunakan
                                  </div>
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                      </div>
                    </b-form-group>
                    
                    <ValidationProvider name="Ukuran Indikator" rules="required" v-slot="{errors}">
                      <b-form-group label="Ukuran">
                        <multiselect 
                          tag-placeholder="Tambahkan ukuran baru" 
                          placeholder="Pilih atau tambahkan ukuran" 
                          selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                          label="name"  track-by="name" 
                          v-model="indicator.measurement" 
                          :options="measurements" 
                          :taggable="true" 
                          :class="errors[0] ? 'invalid': ( indicator.measurement ? 'valid':'')"
                          @input="indicator.measurement_unit = null"
                          @tag="addNewIndicatorMeasurement">
                        </multiselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Satuan Indikator" rules="required" v-slot="{errors}">
                      <b-form-group label="Satuan">
                        <multiselect 
                          tag-placeholder="Tambahkan satuan baru untuk ukuran yang digunakan" 
                          placeholder="Pilih atau tambahkan satuan" 
                          selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                          label="name"  track-by="name" 
                          v-model="indicator.measurement_unit" 
                          :options="indicatorMeasurementUnits" 
                          :taggable="true" 
                          :class="errors[0] ? 'invalid': ( indicator.measurement_unit ? 'valid':'')"
                          @tag="addNewIndicatorMeasurementUnit">
                        </multiselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Subyek Indikator" rules="required" v-slot="{errors}">
                      <b-form-group label="Subyek" description="Pilih subyek yang cocok dengan Indikator">
                        <Treeselect 
                          clearable
                          valueFormat="object"
                          placeholder="Pilih subyek"
                          v-model="indicator.subject_field"
                          :disable-branch-nodes="true"
                          :normalizer="normalizer"
                          :class="errors[0] ? 'invalid': (indicator.subject_field ? 'valid' : null)"
                          :options="options.subject_fields"
                          :loadOptions="loadOptions"
                        >
                          <div slot="option-label" slot-scope="{node}" class="d-flex">
                            <div :style="node.raw.code.length==1 ? 'width:20px':(node.raw.code.length<=4 ? 'width:32px':'width:45px' )">{{node.raw.code}}.</div>
                            <div>{{node.raw.name}}</div>
                          </div>
                        </Treeselect>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Manfaat Indikator" rules="required" v-slot="{errors}">
                      <b-form-group label="Manfaat">
                        <b-form-textarea 
                          rows="3"
                          v-model="indicator.benefit" 
                          placeholder="Manfaat Indikator" 
                          :state="errors[0] ? false: (indicator.benefit ? true : null)"
                        ></b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    
                    <ValidationProvider name="Interpretasi Indikator" rules="required" v-slot="{errors}">
                      <b-form-group label="Interpretasi">
                        <b-form-textarea 
                          rows="3"
                          v-model="indicator.interpretation" 
                          placeholder="Interpretasi Indikator" 
                          :state="errors[0] ? false: (indicator.interpretation ? true : null)"
                        ></b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="Level terkecil tersedianya data Indikator"  rules="required" v-slot="{errors}">
                      <b-form-group label="Level terkecil tersedianya data" description="">
                        <b-form-checkbox-group
                          v-model="indicator.presentation_levels"
                          :state="errors[0] ? false: (indicator.presentation_levels ? true : null)"
                          :options="options.presentation_level"
                          @change="indicatorPresentationLevelChanged"
                        ></b-form-checkbox-group>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                      
                    </ValidationProvider>

                    <ValidationProvider name="Mekanisme Perhitungan" rules="required" v-slot="{errors}">
                      <b-form-group label="Mekanisme Perhitungan Indikator">
                        <b-form-textarea 
                          rows="3"
                          v-model="indicator.calculation_mechanism" 
                          placeholder="Mekanisme Perhitungan Indikator" 
                          :state="errors[0] ? false: (indicator.calculation_mechanism ? true : null)"
                        >
                        </b-form-textarea>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>

                    <b-form-group label="Rumus Indikator">
                      <div class="border m-0 i-shadow bg-white">
                        <div class="px-4 py-3">
                          <ValidationProvider name="Rumus"  rules="required" v-slot="{errors}">
                            <b-form-group label="Rumus" description="Jika tidak ada Rumus, isikan '-'">
                              <EquationEditor id="formula" :value.sync="indicator.formula" size="xl"></EquationEditor>
                              <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                          </ValidationProvider>
                        </div>
                        <div class="p-4 border-top">
                          <ValidationObserver ref="formulaStructuresObserver">
                            <b-form-group label="Keterangan rumus">
                              <b-table-simple class="table--light table--form">
                                <b-thead>
                                  <tr>
                                    <th class="text-center w-40">No</th>
                                    <th class="text-left w-150">Simbol</th>
                                    <th class="text-left pr-0" colspan="2">Deskripsi</th>
                                  </tr>
                                </b-thead>
                                <b-tbody>
                                  <b-tr v-for="(item,index) in indicator.formula_structures" :key="index">
                                    <b-td>
                                      <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                                    </b-td>
                                    <b-td>
                                      <ValidationProvider name="Simbol"  rules="required" v-slot="{errors}">
                                        <b-form-group>
                                          <EquationEditor :value.sync="item.symbol" size="sm"></EquationEditor>
                                          <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                        </b-form-group>
                                      </ValidationProvider>
                                    </b-td>
                                    <b-td class="pr-0">
                                      <ValidationProvider name="Deskripsi Simbol"  rules="required" v-slot="{errors}">
                                        <b-form-group>
                                          <b-form-input 
                                            :state="errors[0] ? false: (item ? true : null)"
                                            v-model="item.description" size="sm"
                                            placeholder="Wilayah, Jenis Kelamin, dan lainnya" ></b-form-input>
                                          <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                        </b-form-group>
                                      </ValidationProvider>
                                    </b-td>
                                    <td class="w-34 pl-0">
                                      <b-button class="button button--action button--action--sm button--danger" 
                                        v-on:click="deleteFormulaStructure(index)" >
                                        <VueFeather type="x" size="17"></VueFeather>
                                      </b-button>
                                    </td>
                                  </b-tr>
                                  <b-tr v-if="indicator.formula_structures.length==0">
                                    <b-td class="text-danger text-center" colspan="6">
                                      <div class="d-flex align-items-center justify-content-center py-1 border-bottom">
                                        <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Belum ada keterangan rumus yang diinput
                                      </div>
                                    </b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                              <b-button class="button button--primary button--sm mt-2" 
                                    v-on:click="addFormulaStructure" >Tambah keterangan</b-button>
                              
                            </b-form-group>
                          </ValidationObserver>
                        </div>
                      </div>
                    </b-form-group>

                    <b-form-group label="Disaggregasi Indikator">
                      <div class="border m-0 i-shadow bg-white">
                        <div class="border-bottom px-4 py-3" style="background-color:#f2f2f2;font-size:13px">
                            Ketika suatu indikator diperlukan untuk diperinci lebih detil dalam penyebaran datanya, 
                            sejumlah variabel digunakan untuk mengklasifikasikan indikator tersebut. 
                            <span class="text-danger">Contoh: penggunaan variabel wilayah (Aceh, Sumatera Utara, lainnya) dan Jenis Kelamin sebagai disaggregasi 
                            Indikator <b>Jumlah Pendududuk</b> </span>
                          </div>
                        <div class="p-4 border-top">
                          <ValidationProvider name="Disaggregasi Indikator" rules="required" v-slot="{errors}">
                            <b-form-group label="Pilih variabel">
                              <Treeselect 
                                placeholder="Pilih variabel"
                                clearable
                                valueFormat="object"
                                v-model="indicatorDisaggregations" 
                                :class="errors[0] ? 'invalid': (indicatorDisaggregations.length>0 ? 'valid' : null)"
                                :multiple="true" 
                                :options="options.variable"
                                :async="true"
                                :loadOptions="variableReferenceLoadOptions"
                                :normalizer="variableNormalizer"
                                @input="indicatorDisaggregationsChanged"
                              >
                              <div slot="option-label" slot-scope="{node}" class="border-bottom">
                                <div style="position:relative;padding: 4px 8px;">
                                  <div style="white-space:initial;line-height:normal;color:#383838">
                                    {{ node.raw.name}}
                                  </div>
                                  <div style="white-space:initial;line-height:normal; font-size:10px !important">
                                    {{ node.raw.data.variable.definition}}
                                  </div>
                                  <div class="d-flex" style="margin:8px 0 10px 0">
                                    <div 
                                      style="padding:2px 5px;height:20px;font-weight:500;font-size:11px" 
                                      :class="'d-flex align-items-center justify-content-center status status--'+statusFormatterStyle(node.raw.status)"
                                    >{{statusFormatter(node.raw.status)}}</div>
                                    <div v-if="node.raw.produsen_data_name"
                                      style="border: 1px solid #dedede;padding:2px 5px;height:20px;font-weight:500;background:#ffffff" 
                                      class="ml-1 text-11 d-flex align-items-center justify-content-center status status--draft">
                                      {{ node.raw.produsen_data_name}}
                                    </div>
                                  </div>                            
                                </div>
                              </div>
                              </Treeselect>
                              <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                          </ValidationProvider>
                          <div class="table-wrapper">
                            <b-table-simple class="table table--light table--bordered" >
                              <b-thead>
                                <tr>
                                  <th class="text-center w-30">No</th>
                                  <th class="text-left w-min-150">Nama</th>
                                  <th class="text-left w-100">Definisi</th>
                                  <th class="text-center w-80">Status</th>
                                  <th class="text-center w-auto">Detail</th>
                                </tr>
                              </b-thead>
                              <b-tbody >
                                <b-tr v-for="(item,index) in indicatorDisaggregations" :key="index">
                                  <b-td class="text-center w-auto">{{index+1}}</b-td>
                                  <b-td class="text-left">{{item.name}}</b-td>
                                  <b-td class="text-left">{{item.data.variable.definition}}</b-td>
                                  <b-td class="text-center w-auto text-nowrap">
                                    <div :class="'status status--'+statusFormatterStyle(item.status)" >
                                      {{statusFormatter(item.status)}}
                                    </div>
                                  </b-td>
                                  <b-td class="text-center w-auto">
                                    <b-button v-if="isRejected(item.status)" type="button" class="button button--action button--action--delete"  @click="showConceptReference(item.id)" style="margin-left:2px">
                                      <VueFeather type="repeat" size="16" stroke-width="2"></VueFeather>
                                    </b-button>
                                    <b-button v-else type="button" class="button button--action button--action--view"  @click="showConceptReference(item.id)"  style="margin-left:2px">
                                      <VueFeather type="eye" size="16" stroke-width="2" ></VueFeather>
                                    </b-button>
                                  </b-td>
                                </b-tr>
                                <b-tr v-if="indicatorDisaggregations.length==0">
                                  <b-td class="text-danger text-center" colspan="6">
                                    <div class="d-flex align-items-center justify-content-center py-1">
                                      <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Tidak variabel yang digunakan sebagai aggregasi
                                    </div>
                                  </b-td>
                                </b-tr>
                              </b-tbody>
                            </b-table-simple>
                          </div>
                        </div>
                      </div>
                    </b-form-group>

                    <ValidationObserver ref="indicatorReferencesObserver">
                      <b-form-group label="Sumber referensi yang digunakan">
                        <b-table-simple class="table--form">
                          <b-tbody >
                            <b-tr v-for="(item,index) in indicator.references" :key="index">
                              <b-td class="w-40">
                                <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                              </b-td>
                              <b-td>
                                <ValidationProvider :name="'Sumber referensi ke-'+(index+1)" rules="required" v-slot="{errors}">
                                  <b-form-input 
                                    type="search"
                                    placeholder="Tuliskan sumber referensi dari indikator yang diusulkan"
                                    v-model="indicator.references[index]"
                                    :state="errors[0] ? false: (item ? true : null)"
                                    size="sm"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </b-td>
                              <td class="w-34">
                                <b-button 
                                  class="button button--action button--action--delete2" 
                                  v-on:click="deleteIndicatorReference(index)" 
                                  :disabled="indicator.references.length==1? true: false"
                                >
                                  <VueFeather type="x" size="17"></VueFeather>
                                </b-button>
                              </td>
                            </b-tr>
                            <tr>
                              <td class="my-0 text-600 v-align-center" colspan="2">Jika Referensi Lebih dari satu bisa melakukan klik tombol tambah</td>
                              <td class="my-0">
                                <b-button  class="button button--action button--action--view2" @click="addIndicatorReference">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                              </td>
                            </tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-form-group>
                    </ValidationObserver>
                  </ValidationObserver>
                </b-form>
              </b-tab>
              <b-tab></b-tab>
            </b-tabs>
          </div>
          <div class="section__footer">
            <div class="section__footer__right">
              <b-button class="button button--outlined mr-1" @click="prev()" v-if="section.currentIndex !=0">Sebelumnya</b-button>
              <b-button class="button button--primary" @click="next()" v-if="section.currentIndex == 0">Selanjutnya</b-button>
            </div>
          </div>
        </div>
      </b-col>
      <Transition name="fade">
        <b-col id="updated-sdsn" cols="3" class="px-0" v-if="updatedSdsnVisible && form.submission_type == 'UPDATE'">
          <div class="section-info">
            <div class="section-info__header">
              <div class="section-info__header__icon">
                <VueFeather type="edit-3" size="16" stroke-width="2" style="display:block"></VueFeather>
              </div>
              <div class="section-info__header__title">
                SDSN yang dimutakhirkan
              </div>
              <div class="section-info__header__close ml-auto">
                <button class="button" variant="icon" size="sm" @click="updatedSdsnVisible = !updatedSdsnVisible">
                  <VueFeather type="x" size="16" stroke-width="2" style="display:block"></VueFeather>
                </button>
              </div>
            </div>
            <div class="section-info__body" >
              <div v-if="form.sds_type == 'CONCEPT'" class="m-3">
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Nama Konsep</div>
                  <div class="py-1">{{concept.updated_concept.items[0].name}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Definsi</div>
                  <div class="py-1">{{concept.updated_concept.items[0].definition}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Sumber Referensi</div>
                  <div>
                    <b-row v-for="(item,index) in concept.updated_concept.items[0].references" :key="index">
                      <b-col v-if="concept.updated_concept.items[0].references>1" style="max-width:40px">{{index+1}}.</b-col>
                      <b-col>{{item}}</b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <div v-if="form.sds_type == 'VARIABLE'" class="m-3">
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Kode</div>
                  <div class="py-1">{{variable.updated_variable.items[0].code}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Nama Variabel</div>
                  <div class="py-1">{{variable.updated_variable.items[0].name}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Definsi</div>
                  <div class="py-1">{{variable.updated_variable.items[0].definition}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Ukuran</div>
                  <div class="py-1">{{variable.updated_variable.items[0].measurement.name}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Satuan</div>
                  <div class="py-1">{{variable.updated_variable.items[0].measurement_unit.name}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Value Domain</div>
                  <b-row v-for="(item,index) in variable.updated_variable.items[0].value_domain.items" :key="index">
                    <b-col>{{item.name}}</b-col>
                  </b-row>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Sumber Referensi</div>
                  <div>
                    <b-row v-for="(item,index) in variable.updated_variable.items[0].references" :key="index">
                      <b-col style="width:10px;max-width:10px" v-if="variable.updated_variable.items[0].references.length>1">{{index+1}}.</b-col>
                      <b-col>{{item}}</b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <div v-if="form.sds_type == 'INDICATOR'" class="m-3">
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Kode</div>
                  <div class="py-1">{{indicator.updated_indicator.items[0].code}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Nama Indikator</div>
                  <div class="py-1">{{indicator.updated_indicator.items[0].name}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Definsi</div>
                  <div class="py-1">{{indicator.updated_indicator.items[0].definition}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Ukuran</div>
                  <div class="py-1">{{indicator.updated_indicator.items[0].measurement.name}}</div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Satuan</div>
                  <div class="py-1">{{indicator.updated_indicator.items[0].measurement_unit.name}}</div>
                </div>
                <div class="mb-2" v-if="indicator.updated_indicator.items[0].disaggregations.length>0">
                  <div class="text-secondary text-bold border-bottom">Disaggregasi Indikator</div>
                  <div>
                    <div>
                      <b-row v-for="(variable,index) in indicator.updated_indicator.items[0].disaggregations" :key="index">
                        <b-col style="width:10px;max-width:10px" v-if="indicator.updated_indicator.items[0].disaggregations.length>1">{{index+1}}</b-col>
                        <b-col>{{variable.name}}</b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <div class="text-secondary text-bold border-bottom">Sumber Referensi</div>
                  <div>
                    <b-row v-for="(item,index) in indicator.updated_indicator.items[0].references" :key="index">
                      <b-col style="width:10px;max-width:10px" v-if="indicator.updated_indicator.items[0].references.length>1">{{index+1}}.</b-col>
                      <b-col>{{item}}</b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
            <div class="section-info__footer"></div>
          </div>
        </b-col>
      </Transition>
    </b-row>
    
    <b-modal hide-header hide-footer size="xl" id="modal-value-domain" modal-class="modal modal--warning">
      <div class="modal__header border-bottom-0">
        <div class="modal__header__title">
          <div class="modal__header__title__name"> 
            <VueFeather type="edit-3" size="22" stroke-width="2"></VueFeather> &nbsp;&nbsp;Tambah Item Value Domain 
          </div>
        </div>
        <div class="modal__header__close">
          <button  class="button button--action button--outlined" @click="$bvModal.hide('modal-value-domain')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body">
        <div class="d-flex align-items-end">
          <div class="text-medium text-16">Daftar Item Klasifikasi </div>
          <div class="d-flex ml-auto align-items-center">
            <label class="text-nowrap m-0 mr-1 text-medium">Jumlah baris:</label>
            <b-form-select v-model="modal.valueDomain.table.pagination.pageSize" :options="options.page" size="sm" ></b-form-select>
          </div>
          
        </div>
        <div class="table-search form">
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Pilih Versi Klasifikasi"
            v-model="modal.valueDomain.statClass"
            :options="options.statistical_classification"
            :normalizer="normalizer"
            @input="options.statistical_classification_level = modal.valueDomain.statClass.levels"
          >
          </Treeselect>
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Pilih Level"
            v-model="modal.valueDomain.level"
            :options="options.statistical_classification_level"
            :normalizer="normalizer"
            :disabled="!modal.valueDomain.statClass" 
            :loadOptions="loadOptions"
            
          >
          </Treeselect>
          
          <b-form-input 
              class="w-400 md"
              type="search"
              debounce="500"
              v-model="modal.valueDomain.name" 
              placeholder="Cari nama item klasifikasi" ></b-form-input>

          <b-button 
            :disabled="modal.valueDomain.statClass == null"
            type="button" 
            class="button button--primary button--md" 
            @click="searchValueDomainItems">
            <VueFeather type="search" size="14" class="button__icon"></VueFeather>Cari Item
          </b-button>
        </div>
        <div class="table-wrapper mt-2">
          <b-table
            class="table--light"
            show-empty
            :items="modal.valueDomain.table.items"
            :fields="modal.valueDomain.table.fields"
          >
            <template #head(selected)>
              <b-form-checkbox class="min-h-0"
                @change="(checked)=>{
                  modal.valueDomain.table.items.forEach(x => {
                    x.selected = checked
                  })
                }"
              ></b-form-checkbox>
            </template>
            <template #cell(selected)="data">
              <b-form-checkbox v-model="data.item.selected"></b-form-checkbox>
            </template>
            <!-- <template #cell(no)="data">
              {{ startRowNumber + data.index}}
            </template> -->

            <template #empty>
              <div class="table__empty">
                <div v-if="modal.valueDomain.table.isLoading">
                  <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                <div v-else class="d-flex flex-column">
                  <div>
                    Tidak ada data yang tersedia
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="modal.valueDomain.table.pagination.currentPage"
            :total-rows="modal.valueDomain.table.pagination.totalElements"
            :per-page="modal.valueDomain.table.pagination.pageSize"
            align="center"
            @input="searchValueDomainItems"
            v-if="modal.valueDomain.table.pagination.totalElements>0 && modal.valueDomain.table.isLoading == false"
          ></b-pagination>
        </div>
      </div>
      <div class="modal__footer">
        <div class="d-flex ml-auto mx-1">
          <b-button type="button" class="button button--outlined" @click="$bvModal.hide('modal-value-domain')">Batal</b-button>
          <!-- <b-button type="button" class="button button--warning ml-2" @click="saveUpdatingSubmissionTypeModal">Simpan</b-button> -->
          <b-button type="button" class="button button--warning ml-2" @click="saveItemAsValueDomain">Simpan sebagai item value domain</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal  hide-header hide-footer id="modal-saving" size="sm" content-class="text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div v-if="saveState=='SAVING'">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Proses menyimpan sedang berlangsung 
          </div>
        </div>
      </div>
      <div v-if="saveState=='SUCCESS'">
        <div class="text-center py-3">
          <img src="@/assets/img/success.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Berhasil menyimpan 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Anda akan di <i>redirect</i> ke halaman approval dalam beberapa detik
          </div>
        </div>
      </div>
      <div v-if="saveState=='ERROR'">
        <div class="text-center py-3" style="color:red">
          <div >
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error 
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{saveError}} 
          </div>
          <div class="mt-2">
            <b-button 
              style="background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-saving');}">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer id="modal-error" size="sm" content-class="modal--error text-center mt-5" dialog-class="d-flex justify-content-center">
      <div>
        <div class="text-center py-5 px-2" style="color:red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div class="border mx-4 " style="border-color:#F48FB1 !important;width:40%">
              <div style="position:relative;background-color:#FCE4EC;height:20px;border-color:#F48FB1 !important" class="border-bottom mb-2" >
                <div style="position:absolute;top:-10px;right:-10px"><VueFeather type="x-circle" size="20" stroke-width="1.5" fill="#FCE4EC"></VueFeather></div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton animation width="85%" height="10px" style="background-color:#fff1f6;border:1px solid #F8BBD0;margin-bottom:10px"></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            {{modal.error.title}} 
          </div>
          <div style="font-weight:500;font-size:13px;color:#616161;word-break: break-word;">
            {{modal.error.description}} 
          </div>
          <div class="mt-3">
            <b-button 
              class="i-button"
              style="color:white !important;background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-error');}">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
     <b-modal hide-header hide-footer size="xl" id="modal-detail-reference" modal-class="modal-secondary primary" >
      <div class="modal__header secondary">
        <div class="modal__header__icon">
          <VueFeather type="info" size="18" stroke-width="2"></VueFeather> 
        </div>
        <div class="">
          <div class="modal__title"> 
            {{modal.conceptReference ? 'Detail Konsep' : 'Detail Variabel'}}
          </div>
          <div class="modal__description"> 
            Informasi lengkap terkait {{modal.conceptReference ? 'Konsep' : 'Variabel'}} yang digunakan
          </div>
        </div>
        <div class="modal__header__close">
          <b-button  class="button button--action button--action--view" @click="$bvModal.hide('modal-detail-reference')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </b-button>
        </div>
      </div>
      <div class="modal__body mt-2">
        <div v-if="modal.isLoading" class="content__loading border-0">
          <img src="@/assets/icons/loading-plane.gif" width="200" height="200" style="margin-top:-60px"/>
          <div style="margin-top:-60px" class="text-center">
            Sedang mengambil data ke server, harap tunggu sebentar....
          </div> 
        </div>
        <div v-else-if="modal.conceptReference">
          <b-table-simple class="table--stacked" :class="isRejected(modal.conceptReference.status) ? 'table--stacked--primary':'table--stacked--primary'">
            <b-tbody>
              <b-tr v-if="modal.alternativeConceptReference">
                <b-th class="text-left"></b-th>
                <b-th>Konsep saat ini</b-th>
                <b-th>Alternatif Konsep yang diusulkan pemeriksa</b-th>
              </b-tr>
              <b-tr>
                <b-th class="w-101">Status</b-th>
                <b-td>
                  <div class="d-flex align-items-center">
                    <div :class="'status status--'+statusFormatterStyle(modal.conceptReference.status)">
                      {{statusFormatter(modal.conceptReference.status)}} 
                      <span v-if="modal.conceptReference.rejection_note && modal.conceptReference.rejection_note.type">
                        : {{rejectedStatusTypeFormatter(modal.conceptReference.rejection_note.type)}}
                      </span>
                    </div>
                  </div>
                </b-td>
                <b-td v-if="modal.alternativeConceptReference">
                  <div :class="'status status--'+statusFormatterStyle(modal.alternativeConceptReference.status)">
                    {{statusFormatter(modal.alternativeConceptReference.status)}}
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th class="w-101">Nama</b-th>
                <b-td>{{modal.conceptReference.data.concept.name}}</b-td>
                <b-td v-if="modal.alternativeConceptReference">
                  {{modal.alternativeConceptReference.data.concept.name}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Definisi</b-th>
                <b-td>{{modal.conceptReference.data.concept.definition}}</b-td>
                <b-td v-if="modal.alternativeConceptReference">
                  {{modal.alternativeConceptReference.data.concept.definition}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Referensi</b-th>
                <b-td>
                   <div v-for="(item,index) in modal.conceptReference.data.concept.references" :key="index" class="d-flex" :class="index > 0 ? 'border-top py-2':'pb-2'">
                    <div v-if="modal.conceptReference.data.concept.references.length>1" class="w-min-20">{{index+1}}. </div>
                    <div style="word-wrap: break-word;">{{item}}</div>
                  </div>
                </b-td>
                <b-td v-if="modal.alternativeConceptReference">
                  <div v-for="(item,index) in modal.alternativeConceptReference.data.concept.references" :key="index" class="d-flex" :class="index > 0 ? 'border-top py-2':'pb-2'">
                    <div v-if="modal.alternativeConceptReference.data.concept.references.length>1" class="w-min-20">{{index+1}}. </div>
                    <div style="word-wrap: break-word;">{{item}}</div>
                  </div>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div v-else-if="modal.variableReference">
          <b-table-simple class="table--stacked table--stacked--primary">
            <b-tbody>
              <b-tr v-if="modal.alternativeVariableReference">
                <b-th class="text-left"></b-th>
                <b-th colspan="3" class="w-50">Variabel Disaggregasi saat ini</b-th>
                <b-th colspan="3" class="w-50">Alternatif Variabel Disaggregasi yang diusulkan pemeriksa</b-th>
              </b-tr>
              <b-tr>
                <b-th class="w-101">Status</b-th>
                <b-td colspan="3">
                  <div class="d-flex align-items-center">
                    <div :class="'status status--'+statusFormatterStyle(modal.variableReference.status)">
                      {{statusFormatter(modal.variableReference.status)}} 
                      <span v-if="modal.variableReference.rejection_note && modal.variableReference.rejection_note.type">
                        : {{rejectedStatusTypeFormatter(modal.variableReference.rejection_note.type)}}
                      </span>
                    </div>
                  </div>
                </b-td>
                <b-td v-if="modal.alternativeVariableReference" colspan="3">
                  <div :class="'status status--'+statusFormatterStyle(modal.alternativeVariableReference.status)">
                    {{statusFormatter(modal.alternativeVariableReference.status)}}
                  </div>
                </b-td>
              </b-tr>
              <b-tr >
                <b-th class="w-101">Nama</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.name}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.name}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th >Definisi</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.definition}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.definition}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th 
                  :rowspan="modal.alternativeVariableReference ? 
                  maxValue([modal.alternativeVariableReference.data.variable.concepts.length, modal.variableReference.data.variable.concepts.length])+1 : 
                  modal.variableReference.data.variable.concepts.length+1">Konsep</b-th>
                <th style="background:none" class="w-51">No</th>
                <th class="text-left w-min-150" style="background:none">Nama</th>
                <th class="text-left w-50" style="background:none">Definisi</th>
                <th v-if="modal.alternativeVariableReference" style="background:none" class="w-51">No</th>
                <th v-if="modal.alternativeVariableReference" class="text-left w-min-150" style="background:none">Nama</th>
                <th v-if="modal.alternativeVariableReference" class="text-left w-50" style="background:none">Definisi</th>
              </b-tr>
              <b-tr 
                v-for="index in modal.alternativeVariableReference ? 
                maxValue([modal.alternativeVariableReference.data.variable.concepts.length, modal.variableReference.data.variable.concepts.length]) : 
                modal.variableReference.data.variable.concepts.length" :key="index">

                <b-td class="text-center">{{index}}</b-td>
                <b-td>{{modal.variableReference.data.variable.concepts[index-1].data.concept.name}}</b-td>
                <b-td>{{modal.variableReference.data.variable.concepts[index-1].data.concept.definition}}</b-td>

                <b-td v-if="modal.alternativeVariableReference" class="text-center">{{index}}</b-td>
                <b-td v-if="modal.alternativeVariableReference">{{modal.alternativeVariableReference.data.variable.concepts[index-1].data.concept.name}}</b-td>
                <b-td v-if="modal.alternativeVariableReference">{{modal.alternativeVariableReference.data.variable.concepts[index-1].data.concept.definition}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Unit Observasi</b-th>
                <b-td colspan="3">
                  <div v-for="(item,index) in modal.variableReference.data.variable.unit_types" :key="index" class="d-flex">
                    <div v-if="modal.variableReference.data.variable.unit_types.length>1" class="w-20">{{index+1}}.</div>
                    <div>{{item.name}}</div>
                  </div>
                </b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  <div v-for="(item,index) in modal.alternativeVariableReference.data.variable.unit_types" :key="index" class="d-flex">
                    <div v-if="modal.alternativeVariableReference.data.variable.unit_types.length>1" class="w-20">{{index+1}}.</div>
                    <div>{{item.name}}</div>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Ukuran</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.measurement ? modal.variableReference.data.variable.measurement.name: '-'}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.measurement ? modal.alternativeVariableReference.data.variable.measurement.name: '-'}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Satuan</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.measurement_unit ? modal.variableReference.data.variable.measurement_unit.name: '-'}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.measurement_unit ? modal.alternativeVariableReference.data.variable.measurement_unit.name: '-'}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th >Subjek</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.subject_field ? modal.variableReference.data.variable.subject_field.name: '-'}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.subject_field ? modal.alternativeVariableReference.data.variable.subject_field.name: '-'}}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th >Jenis Value Domain</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.value_domain.type.id == 76 ? 'Kategori':'Non Kategori'}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.value_domain.type.id == 76 ? 'Kategori':'Non Kategori'}}
                </b-td>
              </b-tr>
              <b-tr v-if="modal.variableReference.data.variable.value_domain.type.id == 76">
                <b-th>Referensi Value Domain</b-th>
                <b-td colspan="3">{{modal.variableReference.data.variable.value_domain.classification_reference? modal.variableReference.data.variable.value_domain.classification_reference:'Tidak menggunakan'}}</b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  {{modal.alternativeVariableReference.data.variable.value_domain.classification_reference? modal.alternativeVariableReference.data.variable.value_domain.classification_reference:'Tidak menggunakan'}}
                </b-td>
              </b-tr>
              <b-tr v-if="modal.variableReference.data.variable.value_domain.type.id == 76">
                <b-th 
                  :rowspan="modal.alternativeVariableReference ? 
                  maxValue([modal.alternativeVariableReference.data.variable.value_domain.items.length, modal.variableReference.data.variable.value_domain.items.length])+1 : 
                  modal.variableReference.data.variable.value_domain.items.length+1">Value Domain</b-th>
                <th class="text-center w-60" style="background:none">Kode</th>
                <th class="text-left w-min-150" style="background:none">Nama</th>
                <th class="text-left w-50" style="background:none">Deskripsi</th>
                <th v-if="modal.alternativeVariableReference" style="background:none" class="w-60">Kode</th>
                <th v-if="modal.alternativeVariableReference" class="text-left w-min-150" style="background:none">Nama</th>
                <th v-if="modal.alternativeVariableReference" class="text-left w-50" style="background:none">Deskripsi</th>
              </b-tr>
              <b-tr 
                v-for="index in modal.variableReference.data.variable.value_domain.type.id != 76 ? 0 : (modal.alternativeVariableReference ? 
                maxValue([modal.alternativeVariableReference.data.variable.value_domain.items.length, modal.variableReference.data.variable.value_domain.items.length]) : 
                modal.variableReference.data.variable.value_domain.items.length)" :key="index+'index'">

                <b-td class="text-center" v-if="modal.variableReference.data.variable.value_domain.type.id == 76">
                  {{ modal.variableReference.data.variable.value_domain.items[index-1] ? modal.variableReference.data.variable.value_domain.items[index-1].code : '-' }}
                </b-td>
                <b-td v-if="modal.variableReference.data.variable.value_domain.type.id == 76">
                  {{ modal.variableReference.data.variable.value_domain.items[index-1] ? modal.variableReference.data.variable.value_domain.items[index-1].name : '-' }}
                </b-td>
                <b-td v-if="modal.variableReference.data.variable.value_domain.type.id == 76">
                  {{ modal.variableReference.data.variable.value_domain.items[index-1] ? modal.variableReference.data.variable.value_domain.items[index-1].description : '-' }}
                </b-td>

                <b-td v-if="modal.alternativeVariableReference" class="text-center">
                   {{ modal.alternativeVariableReference.data.variable.value_domain.items[index-1] ? modal.alternativeVariableReference.data.variable.value_domain.items[index-1].code : '-' }}
                </b-td>
                <b-td v-if="modal.alternativeVariableReference">
                   {{ modal.alternativeVariableReference.data.variable.value_domain.items[index-1] ? modal.alternativeVariableReference.data.variable.value_domain.items[index-1].name : '-' }}
                </b-td>
                <b-td v-if="modal.alternativeVariableReference">
                  {{ modal.alternativeVariableReference.data.variable.value_domain.items[index-1] ? modal.alternativeVariableReference.data.variable.value_domain.items[index-1].description : '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Referensi</b-th>
                <b-td colspan="3">
                   <div v-for="(item,index) in modal.variableReference.data.variable.references" :key="index" class="d-flex" :class="index > 0 ? 'border-top py-2':'pb-2'">
                    <div v-if="modal.variableReference.data.variable.references.length>1" class="w-min-20">{{index+1}}. </div>
                    <div style="word-wrap: break-word;">{{item}}</div>
                  </div>
                </b-td>
                <b-td colspan="3" v-if="modal.alternativeVariableReference">
                  <div v-for="(item,index) in modal.alternativeVariableReference.data.variable.references" :key="index" class="d-flex" :class="index > 0 ? 'border-top py-2':'pb-2'">
                    <div v-if="modal.alternativeVariableReference.data.variable.references.length>1" class="w-min-20">{{index+1}}. </div>
                    <div style="word-wrap: break-word;">{{item}}</div>
                  </div>
                </b-td>
              </b-tr>

            </b-tbody>
          </b-table-simple>
        </div>
      </div>
      <div class="modal__footer border-top-0 pt-0">
        <div class="modal__footer__action">
          <b-button class="button button--sm " :class="modal.alternativeConceptReference || modal.alternativeVariableReference ? 'button--outlined' : 'button--primary' " @click="$bvModal.hide('modal-detail-reference');">Tutup</b-button>
          <b-button class="button button--sm button--primary" 
            v-if="modal.alternativeConceptReference || modal.alternativeVariableReference" @click="useAlternativeReference">Ganti dengan Alternatif</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// defaul scss
import "@/assets/scss/main.scss";
import "@/assets/scss/text.scss";
import SdiOrganizationService from "@/services/SdiOrganizationService";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import lodash from 'lodash';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFeather from 'vue-feather';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import EquationEditor from "../../../components/equation/EquationEditor";
import organizationService from "../../../services/MainService";
import mmsService from "../../../services/MmsService";
import sdsService from "../../../services/SdsService";
import wilayahService from "../../../services/WilayahService";
import store from "../../../store";

import ConceptSubmission from '../data/concept.js';
import IndicatorSubmission from '../data/indicator.js';
import VariableSubmission, { ValueDomainItem } from '../data/variable.js';

import SubjectField from '../data/subject_field.js';
import User from '../data/user.js';

export default {
  name:'CreateUsulanV2',
  components: {
    VueFeather,
    ValidationObserver,
    ValidationProvider,
    Treeselect,
    EquationEditor,
    'multiselect': Multiselect,
  },
  data() {
    return {
      loadingProgress:0,

      settingReleaseDate:null,
      submissionPeriod:null,
      
      produsenData:null,
      walidata:null,

      provinceCode:null,
      cityCode:null,

      section:{
        currentIndex:0,
        items:[
          {
              order: 1,
              id:"ProdusenData",
              name:"Informasi Produsen Data",
              description: "Pilih informasi produsen data, jika belum tersedia Anda dapat mendaftarkan organisasi Anda di menu pengaturan",
              status:null,
          },
          {
              order: 1,
              id:"SDSNList",
              name:"Pilih SDSN / Pengecekan Duplikasi",
              description: "Pilih Standar Data Statistik (SDS) yang ingin dimutakhiran, jika tidak ada Anda dapat mengusulkan baru. Pastikan SDS yang Anda ajukan belum diajukan oleh organisasi lain",
              status:null,
          },
          {
              order: 2,
              id:"SDSSubmission",
              name:"Formulir SDS",
              description: "Rincian informasi terkait Standar Data Statistik yang diajukan",
              status:null,
          },
        ],
      },
      error:null,
      saveState:'SUCCESS',
      saveError:null,
      id:null,

      updatedSdsnVisible: false,

      concept: new ConceptSubmission(),
      variable: new VariableSubmission(),
      variableConcepts:[],
      indicator: new IndicatorSubmission(),
      indicatorConcepts:[],
      indicatorDisaggregations:[],
      form: {
        data: {
          concept: null,
          variable: null,
          indicator: null,
        },
        submission_period: null,
        submission_type: null,
        sds_type: null,
        status: null,
        rejection_note: null,
        alternative_sds_item_id: null,
        rejected_similiar_item_ids:[],
        submitter: null,
        produsen_data: null,
        walidata_pusat: null,
        reviews:[],
        proposed_walidata_kabupaten_kota:	false,
        proposed_walidata_provinsi:	false,
        proposed_walidata_pusat:	false,
      },
      modal:{
        isLoading:null,
        error:{
          title:null,
          description:null,
        },
        valueDomain:{
          statClass:null,
          level:null,
          name:null,
          table:{
            isLoading:null,
            items: [],
            fields:[
              {
                key:'selected',
                label:'',
                class:'text-center w-51'
              },
              {
                key: 'code',
                label: 'Kode',
                class:'text-left text-nowrap w-101'
              },
              {
                key: 'name',
                label: 'nama',
                class:'text-left text-nowrap w-150'
              },
              {
                key:'description',
                label: 'deskripsi',
                class:'text-left'
              }
            ],
            pagination:{
              currentPage:1,
              pageSize: 10,
              totalPages: null,
              totalElements:0,
            },
          },
        },
        conceptReference:null,
        variableReference:null,
        alternativeConceptReference:null,
        alternativeVariableReference:null,
      },
      user:new User(),
      userRoles:[],
      sdsn:[],
      selectedSdsn:null,
      formFilter:{
        name:null,
      },
      table:{
        isLoading:false,
        items: [],
        fields:[
          {
            key:'no',
            class:'text-center w-51'
          },
          {
            key: 'submission_type',
            label: 'Jenis Usulan',
            class:'text-left text-nowrap w-101'
          },
          {
            key: 'sds_type',
            label: 'Jenis Sds',
            class:'text-left text-nowrap w-70'
          },
          {
            key:'name',
            label: 'Nama',
            class:'text-left'
          },
          {
            key:'requester.name',
            label: 'Nama Pengentri',
            class:'text-left w-140'
          },
          {
            key:'requester.organization.name',
            label: 'Organisasi Pengentri',
            class:'text-left w-140'
          },
          {
            key:'produsen_data_name',
            label: 'Produsen Data',
            class:'text-left w-140'
          },
          {
            key:'created_at',
            label: 'Tanggal Usulan',
            class:'text-left text-nowrap w-110'
          },
          {
            key:'status',
            class:'text-center text-nowrap w-101'
          },
          {
            key:'action',
            label: 'Aksi',
            class:'text-center text-nowrap w-101'
          },
        ],
        pagination:{
          currentPage:1,
          pageSize: 10,
          totalPages: null,
          totalElements:0,
        },
      },
      fields: [
        {
          key:'no',
          class:'text-center'
        },
        {
          key: 'idSds',
          label: 'Kode SDSN',
          class:'text-left text-nowrap'
        },
        {
          key: 'noIndikator',
          label: 'No. Indikator',
          class:'text-left text-nowrap'
        },
        {
          key:'konsep',
          class:'text-left'
        },
        {
          key:'definisi',
          class:'text-left'
        },
        {
          key:'klasifikasi',
          class:'text-left'
        },
        {
          key:'ukuran',
          class:'text-left'
        },
        {
          key:'satuan',
          class:'text-left'
        },
        {
          key:'action',
          label:'Update SDS',
          class:'text-center'
        },
      ],
      pagination:{
        currentPage:1,
        pageSize: 10,
        first:null,
        last:null,
        totalPages: null,
        totalElements:null,
        initialTotalElements:null,
        initialLoad:false,
      },
      sortBy:[
        {
          property: "idSds",
          direction: null
        },
        {
          property: "noIndikator",
          direction: null
        },
        {
          property: "konsep",
          direction: null
        }
      ],
      filterIdSdsValue:null,
      filterIndicatorNoValue:null,
      filterConceptValue:null,
      classificationReferenceId:null,
      classificationReferenceUsedType:'FULL',
      
      options:{
        page:[
          { value: 10, text: '10' },
          { value: 20, text: '20' },
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 500, text: '500' },
          { value: 1000, text: '1000' },
        ],
        sds_type:[
          {value:'CONCEPT', text:'Konsep & Definisi'},
          {value:'VARIABLE', text:'Variabel'},
          {value:'INDICATOR', text:'Indikator'},
        ],
        value_domain_type:[
          { value: { id: 75, name: 'Described Value Domain', description:'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi' }, text: 'Non Kategori',},
          { value: { id: 76, name: 'Enumerated Value Domain', description: 'Jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori' }, text: 'Kategori' },
        ],
        concept:[],
        variable:[],
        unit_type:[],
        measurement:[],
        measurement_unit:[],
        classification_series:[],
        statistical_classification:[],
        statistical_classification_level:[],
        presentation_level:[
          { value: { id: 148, name: 'Nasional', description: null}, text: 'Nasional'},
          { value: { id: 149, name: 'Provinsi', description: null}, text: 'Provinsi'},
          { value: { id: 150, name: 'Kabupaten/Kota', description: null}, text: 'Kabupaten/Kota'},
          { value: { id: 151, name: 'Kecamatan', description: null}, text: 'Kecamatan'},
          { value: { id: 152, name: 'Kelurahan/Desa', description: null}, text: 'Kelurahan/Desa'}
        ],
        subject_fields:null,
        rejected_status_type :[
          {id:'SIMILAR_SDSN_ALREADY_EXISTS', label:'Sudah ada SDSN yang serupa'},
          {id:'SIMILAR_REQUEST_ALREADY_EXISTS', label:'Sudah ada Usulan yang serupa'},
          {id:'IMPROPERLY_REQUEST', label:'Usulan tidak layak'},
          {id:'REQUESTED_BY_USER', label:'Diminta oleh pengusul'},
          {id:'OTHER', label:'Lainnya'},
        ],
        status:[
          {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
          {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
          {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
          {value:'CORRECTION_KABKOTA', label:'Perlu perbaikan Produsen Data Kabupaten/Kota'},
          {value:'REVISED_KABKOTA', label:'Sudah diperbaiki Produsen Data Kabupaten/Kota'},
          {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
          {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
          {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

          {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
          {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
          {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
          {value:'CORRECTION_PROVINSI', label:'Perlu perbaikan Produsen Data Provinsi'},
          {value:'REVISED_PROVINSI', label:'Sudah diperbaiki Produsen Data Provinsi'},
          {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
          {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
          {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

          {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
          {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
          {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
          {value:'CORRECTION_PUSAT', label:'Perlu perbaikan Produsen Data Pusat'},
          {value:'REVISED_PUSAT', label:'Sudah diperbaiki Produsen Data Pusat'},
          {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
          {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
          {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
          {value:'PUBLISHED_PUSAT', label:'Publish'},
        ],
        submissionPeriod:[],
        organization:[],
        produsenData:[],
        division:[],
        province:[
          {
            id: 0,
            code: '00',
            name: "PUSAT",
          },
          {
            id: 1,
            code: 11,
            name: "ACEH"
          },
          {
            id: 2,
            code: 12,
            name: "SUMATERA UTARA"
          },
          {
            id: 3,
            code: 13,
            name: "SUMATERA BARAT"
          },
          {
            id: 4,
            code: 14,
            name: "RIAU"
          },
          {
            id: 5,
            code: 15,
            name: "JAMBI"
          },
          {
            id: 6,
            code: 16,
            name: "SUMATERA SELATAN"
          },
          {
            id: 7,
            code: 17,
            name: "BENGKULU"
          },
          {
            id: 8,
            code: 18,
            name: "LAMPUNG"
          },
          {
            id: 9,
            code: 19,
            name: "KEPULAUAN BANGKA BELITUNG"
          },
          {
            id: 10,
            code: 21,
            name: "KEPULAUAN RIAU"
          },
          {
            id: 11,
            code: 31,
            name: "DKI JAKARTA"
          },
          {
            id: 12,
            code: 32,
            name: "JAWA BARAT"
          },
          {
            id: 13,
            code: 33,
            name: "JAWA TENGAH"
          },
          {
            id: 14,
            code: 34,
            name: "DI YOGYAKARTA"
          },
          {
            id: 15,
            code: 35,
            name: "JAWA TIMUR"
          },
          {
            id: 16,
            code: 36,
            name: "BANTEN"
          },
          {
            id: 17,
            code: 51,
            name: "BALI"
          },
          {
            id: 18,
            code: 52,
            name: "NUSA TENGGARA BARAT"
          },
          {
            id: 19,
            code: 53,
            name: "NUSA TENGGARA TIMUR"
          },
          {
            id: 20,
            code: 61,
            name: "KALIMANTAN BARAT"
          },
          {
            id: 21,
            code: 62,
            name: "KALIMANTAN TENGAH"
          },
          {
            id: 22,
            code: 63,
            name: "KALIMANTAN SELATAN"
          },
          {
            id: 23,
            code: 64,
            name: "KALIMANTAN TIMUR"
          },
          {
            id: 24,
            code: 65,
            name: "KALIMANTAN UTARA"
          },
          {
            id: 25,
            code: 71,
            name: "SULAWESI UTARA"
          },
          {
            id: 26,
            code: 72,
            name: "SULAWESI TENGAH"
          },
          {
            id: 27,
            code: 73,
            name: "SULAWESI SELATAN"
          },
          {
            id: 28,
            code: 74,
            name: "SULAWESI TENGGARA"
          },
          {
            id: 29,
            code: 75,
            name: "GORONTALO"
          },
          {
            id: 30,
            code: 76,
            name: "SULAWESI BARAT"
          },
          {
            id: 31,
            code: 81,
            name: "MALUKU"
          },
          {
            id: 32,
            code: 82,
            name: "MALUKU UTARA"
          },
          {
            id: 33,
            code: 91,
            name: "PAPUA BARAT"
          },
          {
            id: 34,
            code: 94,
            name: "PAPUA"
          }
        ],
        city:[
          {
            id: 0,
            kode: '0000',
            nama: "PUSAT",
            provinsiId:null
          }
        ]
      }
    };
  },
  computed: {
    measurements(){
      return this.options.measurement.map(({id, name, description}) => ({id, name, description}));
    },
    variableMeasurementUnits(){
      if(this.variable.measurement != null){
        return this.options.measurement.find(x => x.name == this.variable.measurement.name).measurement_units;
      }
      return  [];
    },
    indicatorMeasurementUnits(){
      if(this.indicator.measurement != null){
        return this.options.measurement.find(x => x.name == this.indicator.measurement.name).measurement_units;
      }
      return  [];
    },
    isLoading(){
      return this.loadingProgress < 100 ? true : false;
    },
    startRowNumber(){
      return this.pagination.totalElements == 0 ? '0' : (this.pagination.currentPage-1)*this.pagination.pageSize+1; 
    },
    isSDNSPublished(){
      if(this.settingReleaseDate){
        return new Date() >= new Date(this.settingReleaseDate) ? true : false;
      }
      return false
    },
    isAdmin(){
      return this.userRoles.includes("ROLE_SUPERADMIN")
    },
    isPusat(){
      return this.isAdmin || this.isPembinaDataPusat || this.isWalidataPusat || this.isProdusenDataPusat;
    },
    isProvinsi(){
      return this.isPembinaDataProvinsi|| this.isWalidataProvinsi|| this.isProdusenDataProvinsi;
    },
    isKabupatenKota(){
      return this.isPembinaDataKabupatenKota || this.isWalidataKabupatenKota|| this.isProdusenDataKabupatenKota;
    },
    isPembinaDataPusat(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PUSAT")
    },
    isPembinaDataProvinsi(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI")
    },
    isPembinaDataKabupatenKota(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI")
    },
    isWalidata(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT") || this.userRoles.includes("ROLE_WALIDATA_PROVINSI") || this.userRoles.includes("ROLE_WALIDATA_KABUPATEN_KOTA");
    },
    isWalidataPusat(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT");
    },
    isWalidataProvinsi(){
      return this.userRoles.includes("ROLE_WALIDATA_PROVINSI")
    },
    isWalidataKabupatenKota(){
      return this.userRoles.includes("ROLE_WALIDATA_KABKOTA")
    },
    isProdusenDataPusat(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_PUSAT");
    },
    isProdusenDataProvinsi(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_PROVINSI")
    },
    isProdusenDataKabupatenKota(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA")
    },
    isProdusenData(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_PUSAT") || this.userRoles.includes("ROLE_PRODUSEN_DATA_PROVINSI") || this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
    },
    
  },
  watch:{
    'formFilter.name'(){
      this.filterSdsItemList();
    },
    filterConceptValue(){
      this.resetSortSdsn();
      this.getSdsnList();
    },
    filterIdSdsValue(){
      this.resetSortSdsn();
      this.getSdsnList();
    },
    filterIndicatorNoValue(){
      this.resetSortSdsn();
      this.getSdsnList();
    },
    async provinceCode(){
      if(this.provinceCode){
         let prov = this.options.province.find(x=>x.code == this.provinceCode);
         if(this.cityCode && this.cityCode.substr(0, 2) != this.provinceCode){
         this.cityCode = null;
         }
         if(this.provinceCode == '00'){
            this.options.city = [{
               id: 0,
               kode: '0000',
               nama: "PUSAT",
               provinsiId:null
            }];
         }else{
            await wilayahService.getKabupatenKotaByIdProvinsi(prov.id).then(
               (result) => {
                     let options = result.data.data;
                     this.options.city = options;
                     this.options.city = [
                        {
                           id: 9999,
                           kode: this.provinceCode+'00',
                           nama: "PROVINSI",
                           provinsiId:0
                        }, ...this.options.city]
               },
               (error) => {
                     this.error=error;
               }
            );
         }
      }else{
         this.cityCode = null
      }
    },
  },
  async mounted() {
    this.setSubmissionPeriod();
    this.getUserInfo(store.getters["auth/user"]);
    await Promise.all([
      this.setUpSetting(), 
      this.getUnitTypeList(),
      this.getMeasurementList(),
      this.getClassificationSeriesList(),
    ]);
    if(this.isSDNSPublished){
      await this.getSdsnList();
    }else{
      await this.filterSdsItemList();
    }
    this.setSubjectFieldsOptions();
    

    if(this.isPusat){
      this.provinceCode = '00';
      this.cityCode = '0000';
    }
    else if(this.isProvinsi){
      this.provinceCode = this.user.organization.province.code;
      this.cityCode = this.user.organization.province.code + '00';
    }else{
      this.provinceCode = this.user.organization.province.code;
      this.cityCode = this.user.organization.city.code;
    }
    this.setInitialRightPanel();
  },
  methods: {
    setSubmissionPeriod(){
        let currentYear = new Date().getFullYear();
        this.submissionPeriod = currentYear;
        this.form.submission_period = this.submissionPeriod;
        this.options.submissionPeriod = this.generateYearList(2021, currentYear).reverse().map(x=>({id: parseInt(x), label:x}));
    },
    generateYearList(start, stop, step = 1){
        return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    },
    async setUpSetting(){
      await sdsService.getSettings().then(
        (result)=>{
          this.settingReleaseDate = result.data.body.filter(x=>x.property == 'released_date')[0].value;
        },
        (error)=>{
          console.log(error)
        }
      )
    },
    setCurrentIndex(index){
        this.section.currentIndex = index;
    },
    setSubjectFieldsOptions(){
      let subjects =  [...SubjectField]
      
      let lv1 = subjects.filter(x=> x.level == 1);
      let lv2 = subjects.filter(x=> x.level == 2);
      let lv3 = subjects.filter(x=> x.level == 3);

      lv2 = lv2.map(item => {
        let lv2_children = lv3.filter(x => x.parent == item.id).map(({id,code,name,description})=>({id,code,name,description}))
        item = { id: item.id, code: item.code, name: item.name, description: item.description, parent: item.parent }
        return lv2_children.length>0 ? {...item, ...{children: lv2_children}} : item;
      })
      lv1 = lv1.map(item => {
        let lv1_children = lv2.filter(x => x.parent == item.id).map(x=> {delete x.parent; return x});
        return { id: item.id, code: item.code,  name: item.name, description: item.description, children: lv1_children }
      })
      this.options.subject_fields = lv1;
    },
    async save(status){
      let valid = true;
      if(status == 'DRAFT'){
        if(this.form.produsen_data == null){
          valid = false;
          this.modal.error.description = 'Untuk dapat menyimpan dalam bentuk DRAFT, Produsen Data tidak boleh kosong';
        }
        if(this.form.sds_type == null || (this.form.sds_type == 'CONCEPT' && this.concept.name==null) || (this.form.sds_type == 'VARIABLE' && this.variable.name==null) || (this.form.sds_type == 'INDICATOR' && this.indicator.name==null)){
          valid = false;
          this.modal.error.description = 'Untuk dapat menyimpan dalam bentuk DRAFT, nama Konsep & Definisi/Variabel/Indikator tidak boleh kosong';
        }
      }else{
        valid = await this.validateAllForm();
        if(!valid){
          this.modal.error.description = 'Pastikan Semua isian sudah dalam keadaan valid';
        }
      }

      if(valid){
        if(this.produsenData){
          let level = this.produsenData.level;
          if(level == 'PUSAT'){
            this.form.status = status == 'DRAFT' ? 'DRAFT_PUSAT' : 'SUBMITTED_PUSAT'
          }else if(level == 'PROVINSI'){
            this.form.status = status == 'DRAFT' ? 'DRAFT_PROVINSI' : 'SUBMITTED_PROVINSI'
          }else{
            this.form.status = status == 'DRAFT' ? 'DRAFT_KABKOTA' : 'SUBMITTED_KABKOTA'
          }
        }else{
          this.form.status = status == 'DRAFT' ? 'DRAFT_KABKOTA' : 'SUBMITTED_KABKOTA'
        }
        this.sendData();
      }else{
        this.modal.error.title = 'Isian Error';
        this.$bvModal.show('modal-error');
      }
    },
    async validateAllForm(){
      let valid = false;
      valid = await this.$refs.sdsTypeObserver.validate();
      if(this.form.sds_type == 'CONCEPT'){
        valid = await this.$refs.conceptObserver.validate();
        valid = valid && await this.$refs.conceptReferencesObserver.validate();
      }else if(this.form.sds_type == 'VARIABLE'){
        valid = await this.$refs.variableObserver.validate();
        valid = valid && await this.$refs.variableReferencesObserver.validate();
        if(this.variable.value_domain.type.id==76){
          valid = valid && await this.$refs.valueDomainItemsObserver.validate();
          if(this.variable.value_domain.classification_reference !=null && this.classificationReferenceUsedType=='PARTIAL' && this.variable.value_domain.items.length==0){
            valid = false
          }
        }
      }else{
        valid = await this.$refs.indicatorObserver.validate();
        valid = valid && await this.$refs.indicatorReferencesObserver.validate();
        valid = valid && await this.$refs.formulaStructuresObserver.validate();
      }
      return valid;
    },
    async sendData(){
      
      this.form.data= {
        concept: null,
        variable: null,
        indicator:null,
      }
      if(this.form.sds_type == 'CONCEPT'){
        this.form.data.concept = this.concept;
      }else if(this.form.sds_type == 'VARIABLE'){
        if(this.variable.value_domain.type && this.variable.value_domain.type == 75){
          this.variable.value_domain.items = [];
          this.variable.value_domain.classification_reference=null;

        }
        this.form.data.variable = this.variable;
      }else{
        this.form.data.indicator = this.indicator;
      }
      this.$bvModal.show('modal-saving');
      this.saveState = 'SAVING';

      await sdsService.addSdsItem(this.form).then(
        (result) => {
          let response = result.data.result[0];
          if(response.status == 403 || response.status == 500){
            if(response.status == 403){
              this.modal.error.title = 'Forbidden';
              this.modal.error.description = 'Anda tidak mempunyai akses untuk menambahkan item';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.hide('modal-saving');
            this.$bvModal.show('modal-error');
          }else{
            this.saveState = 'SUCCESS';
            this.delay(2000).then(() => this.$router.push('/old-sds/daftar-usulan'));
          }
        },
        (error) => {
          this.saveState = 'ERROR';
          this.saveError = error.response;
        }
      );
    },
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
      this.form.submitter = this.user;
    },
    async getSdsnList() {
      let idSds = this.filterIdSdsValue;
      let noIndikator = this.filterIndicatorNoValue;
      let judulIndikator = null;
      let konsep = this.filterConceptValue;
      let definisi = null;
      let klasifikasi = null;
      let ukuran = null
      let satuan = null;
      let flag = null;

      let sortBy = this.sortBy.filter(x => x.direction != null);

      await sdsService.getSdsnList( idSds, noIndikator, judulIndikator, konsep, definisi, klasifikasi, ukuran, satuan, flag,
          this.pagination.currentPage-1,this.pagination.pageSize, sortBy).then(
        (result) => {
          this.response = result;
          let response = result.data;
          
          this.sdsn = response.content.map(item => ({...item, selected: false}));
          this.pagination.first = response.first;
          this.pagination.last = response.last;
          this.pagination.totalPages = response.tototalPagestal_pages;
          this.pagination.totalElements = response.totalElements
          
          if(!this.pagination.initialLoad){
            this.pagination.initialTotalElements = response.totalElements
            this.pagination.initialLoad =true;
          }
          this.selectedAll=false;
        },
        (error) => {
            console.log(error);
        }
      );
      
    },
    async filterSdsItemList(){
      let page = this.table.pagination.currentPage-1;
      let name = this.formFilter.name;
      let query ="submissionPeriod="+(this.submissionPeriod-1)+"&page="+page+"&size=10";
      if(name){
        query += "&name="+name;
      }
      this.table.isLoading = true;
      this.table.items = [];
      await sdsService.getSdsItemListByQuery(query).then(
        (result)=>{
          let response = result.data;
          this.table.items = response.content;
          this.table.pagination.totalPages = response.total_pages;
          this.table.pagination.totalElements= response.total_elements;
        },
        (error)=>{
          console.log(error)
        }
      )
      this.table.isLoading = false;
      
    },
    async getOrganizationById(id){
      await organizationService.getOrganizationById(id).then(
        (result)=>{
          let x = result.data[0];
          this.produsenData = x
        },
        (error)=>{
          console.log(error)
        }
      )
    },
    resetSortSdsn(){
      this.sortBy= [
        {
          property: "idSds",
          direction: null
        },
        {
          property: "noIndikator",
          direction: null
        },
        {
          property: "konsep",
          direction: null
        }
      ];
    },
    sortSdsn(sortOrder){
      if(sortOrder.direction == null){
        sortOrder.direction = "asc";
      }else if(sortOrder.direction == "asc"){
        sortOrder.direction = "desc";
      }else{
        sortOrder.direction = null;
      }
      this.getSdsnList()
    },
    goTo(link){
      this.$router.push(link);
    },
    
    checkPermission(status){
      if (this.roles.includes('ROLE_SUPERADMIN') || status == 'DRAFT') {
        return true;
      } else {
        return false;
      }
    },
    //step 1 function :list
    createSds(){
      this.section.currentIndex=2;
      this.form.submission_type = 'NEW'
      this.form.sds_type='CONCEPT';
    },
    updateSds(sdsn){
      this.section.currentIndex=2;
      
      this.form.submission_type = 'UPDATE'
      this.form.sds_type='CONCEPT';
      this.selectedSdsn = sdsn;

      this.concept.updated_concept = {
        changes_type:'MODIFY',
        items:[
          {
            id: sdsn.id,
            code: sdsn.idSds,
            name: sdsn.konsep,
            definition: sdsn.definisi,
            references: [sdsn.sumberContent]
          }
        ]
      };
      this.variable.updated_variable = {
        changes_type:'MODIFY',
        items:[
          {
            id: sdsn.id,
            code: sdsn.idSds,
            name: sdsn.konsep,
            definition: sdsn.definisi,
            concepts: [],
            unit_types: [],
            measurement: {
              id: null,
              name: sdsn.ukuran,
              description: null,
            },
            measurement_unit: {
              id: null,
              symbol: null,
              name: sdsn.satuan,
            },
            subject_field: null,
            value_domain: {
              type: null,
              classification_reference: null,
              items: [
                  {
                    id: null,
                    code: null,
                    name: sdsn.klasifikasi,
                    description: null,
                    parent_code:null,
                    level:null,
                  }
              ],
              total_levels:null,
            },
            rule: null,
            references: [sdsn.sumberContent],
          }
        ]
      }
      this.indicator.updated_indicator = {
        changes_type:'MODIFY',
        items:[
          {
            id: sdsn.id,
            code: sdsn.idSds,
            name: sdsn.konsep,
            definition: sdsn.definisi,
            concepts: [],
            measurement: {
              id: null,
              name: sdsn.ukuran,
              description: null,
            },
            measurement_unit: {
              id: null,
              symbol: null,
              name: sdsn.satuan,
            },
            subject_field: null,
            benefit: null,
            interpretation: null,
            presentation_levels: [],
            calculation_mechanism: null,
            formula: null,
            formula_structures: [],
            disaggregations: [
              {
                id: null,
                code: null,
                name: sdsn.klasifikasi,
                definition: null,
                concepts: [],
                unit_types: [],
                measurement: null,
                measurement_unit: null,
                subject_field: null,
                value_domain: null,
                rule: null,
                references: [],
              }
            ],
            references: [sdsn.sumberContent],
          }
        ]
      };
    },
    //api function
    
    async getUnitTypeList(){
      await mmsService.getUnitTypeList().then(
        (result) => {
          let response = result.data.result[0];
          this.options.unit_type = response;
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async getMeasurementList(){
      await mmsService.getMeasurementList().then(
        (result) => {
          let response = result.data.result[0];
          this.options.measurement = response;
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async getClassificationSeriesList(){
      await mmsService.getClassificationSeries('type=Classification&size=100').then(
        (result) => {
          let response = result.data.result[0].content;
          this.options.classification_series = response.map(x=>{
            return { 
                text: x.name + ' ('+x.abbreviation+')', 
                value: {
                  id:x.id,
                  name:x.name,
                  description:x.description,
                  used_type: 'FULL'
                }
            }
          });
          this.options.classification_series.push(
            {
              text: 'Tidak menggunakan', 
              value: null
            }
          );
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async getStatisticalClassificationByClassificationSeries(id){
      await mmsService.getStatisticalClassificationByClassificationSeries(id).then(
        (result) => {
          let response = result.data.result[0].content;
          this.options.statistical_classification  = response;
          
        },
        (error) => {
          this.error=error;
        }
      );
    },
    keyValueFormatter(keyValues){
      let result = keyValues.map(record => {
        let row = {id:record.id};
        record.attributes.forEach(attribute => {
          let column = {[attribute.en_name.replace(/ /g,"_")]:attribute.value}
          row = {...row,...column};
        })
        return row;
      });
      return result;
    },
    //step 2 function :form
    addNewUnitType(new_unit_type){
      let new_item = {
        id: null,
        name: new_unit_type,
        description:null,
      }
      this.options.unit_type.push(new_item)
      this.variable.unit_types.push(new_item)
    },
    addNewVariableMeasurement(new_measurement_name){
      let new_measurement = {
        id:null,
        name:new_measurement_name,
        description:null,
      };
      this.options.measurement.push({...new_measurement,...{measurement_units:[]}});
      this.variable.measurement = new_measurement;
      this.variable.measurement_unit = null;
    },
    addNewVariableMeasurementUnit(new_measurement_unit_name){
      let new_measurement_unit = {
        id: null,
        name: new_measurement_unit_name,
        symbol: null
      } 
      this.options.measurement.forEach(x => {
        if(x.name == this.variable.measurement.name){
          x.measurement_units.push(new_measurement_unit)
        }
      });
      this.variable.measurement_unit = new_measurement_unit;
    },
    
    addNewIndicatorMeasurement(new_measurement_name){
      let new_measurement = {
        id: null,
        name: new_measurement_name,
        description: null,
      };
      this.options.measurement.push({...new_measurement,...{measurement_units:[]}});
      this.indicator.measurement = new_measurement;
      this.indicator.measurement_unit = null;
    },
    addNewIndicatorMeasurementUnit(new_measurement_unit_name){
      let new_measurement_unit = {
        id: null,
        name: new_measurement_unit_name,
        symbol: null
      } 
      this.options.measurement.forEach(x => {
        if(x.name == this.indicator.measurement.name){
          x.measurement_units.push(new_measurement_unit)
        }
      });
      this.indicator.measurement_unit = new_measurement_unit;
    },
    indicatorPresentationLevelChanged(){
      let presentation_levels = [...this.indicator.presentation_levels];
      let provExisted = presentation_levels.filter(x =>x.id == 149).length>0 ? true : false;
      if(provExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null}
        ]
      }

      let kabExisted = presentation_levels.filter(x =>x.id == 150).length>0 ? true : false;
      if(kabExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null},
          { id: 150, name: 'Kabupaten/Kota', description: null},
        ]
      }

      let kecExisted = presentation_levels.filter(x =>x.id == 151).length>0 ? true : false;
      if(kecExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null},
          { id: 150, name: 'Kabupaten/Kota', description: null},
          { id: 151, name: 'Kecamatan', description: null},
        ]
      }

      let kelExisted = presentation_levels.filter(x =>x.id == 152).length>0 ? true : false;
      if(kelExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null},
          { id: 150, name: 'Kabupaten/Kota', description: null},
          { id: 151, name: 'Kecamatan', description: null},
          { id: 152, name: 'Kelurahan/Desa', description: null}
        ]
      }
    },
    valueDomainTypeChanged(){
      if(this.variable.value_domain.type.id == 76 && this.variable.value_domain.items.length == 0){
        this.variable.value_domain.items.push(new ValueDomainItem());
      }
    },
    valueDomainClassificationReferenceChanged(){
      this.variable.value_domain.items=[];
      if(this.variable.value_domain.classification_reference){
        this.classificationReferenceUsedType='FULL';
      }else{
        this.variable.value_domain.items.push(new ValueDomainItem());
      }      
    },
    classificationReferenceUsedTypeChanged(){
      this.variable.value_domain.classification_reference.used_type = this.classificationReferenceUsedType;
      this.variable.value_domain.items=[];
      if(this.classificationReferenceUsedType == 'FULL'){
        this.variable.value_domain.items=[];
      }
    },
    showModalValueDomain(classificationSeriesId){
      this.getStatisticalClassificationByClassificationSeries(classificationSeriesId)
      this.$bvModal.show('modal-value-domain');
    },
    async searchValueDomainItems(){
      let statClassId = this.modal.valueDomain.statClass.id;
      let levelId = this.modal.valueDomain.level.id;
      let name = this.modal.valueDomain.name;
      this.modal.valueDomain.table.items=[];
      this.modal.valueDomain.table.isLoading=true;
      let page = this.modal.valueDomain.table.pagination.currentPage-1;
      let size = this.modal.valueDomain.table.pagination.pageSize;
      await mmsService.getStatisticalClassificationItems(statClassId, levelId, null, name, page, size).then(
        (result) => {
          let response = result.data.result[0];
          this.modal.valueDomain.table.items = response.content.map(item => ({...item, selected: false}));
          this.modal.valueDomain.table.pagination.totalPages = response.total_pages;
          this.modal.valueDomain.table.pagination.totalElements= response.total_elements;
          
        },
        (error) => {
          this.error=error;
        }
      );
      this.modal.valueDomain.table.isLoading=false;
    },
    saveItemAsValueDomain(){
      this.modal.valueDomain.table.items.filter(x=>x.selected==true).forEach(x=>{
        let newItem = {
          id: x.id,
          code:x.code,
          name: x.name,
          description: x.description,
          parent: x.parent_id ? {
            id:x.parent_id,
            code:null
          } : null,
        }
        this.variable.value_domain.items.push(newItem);
      })
      this.$bvModal.hide('modal-value-domain')
      
    },
    async addNewVariableValueDomain(){
      let newItem = {
        id: null,
        code: null,
        name: null,
        description: null,
        parent:{
          id: null,
          code: null
        }
      }
      if(this.variable.value_domain.items.length>0){
        let valid = await this.$refs.valueDomainItemsObserver.validate();
        if(valid){
          this.variable.value_domain.items.push(newItem);
        }
      }else{
        this.variable.value_domain.items.push(newItem);
      }
    },
    deleteVariableValueDomain(deletedIndex){
       this.variable.value_domain.items =  this.variable.value_domain.items
        .filter((items,index) => index != deletedIndex);
    },
    deleteIndicatorConcept(deletedIndex){
      this.indicator.concepts = this.indicator.concepts
        .filter((items,index) => index != deletedIndex);
    },
    deleteIndicatorDisagregation(deletedIndex){
      this.indicator.disaggregations = this.indicator.disaggregations
        .filter((items,index) => index != deletedIndex);
    },
    async addFormulaStructure(){
      let valid = await this.$refs.formulaStructuresObserver.validate();
      if(valid){
        this.indicator.formula_structures.push({symbol:null,description:null});
      }
    },
    deleteFormulaStructure(deletedIndex){
      this.indicator.formula_structures = this.indicator.formula_structures
        .filter((items,index) => index != deletedIndex);
    },
    async addConceptReference(){
      if(this.concept.references.length>0){
        let valid = await this.$refs.conceptReferencesObserver.validate();
        if(valid){
          this.concept.references.push('');
        }
      }
      else{
        this.concept.references.push('');
      }
    },
    deleteConceptReference(deletedIndex){
      this.concept.references = this.concept.references
        .filter((items,index) => index != deletedIndex);
    },
    async addVariableReference(){
      if(this.variable.references.length>0){
        let valid = await this.$refs.variableReferencesObserver.validate();
        if(valid){
          this.variable.references.push('');
        }
      }
      else{
        this.variable.references.push('');
      }
    },
    deleteVariableReference(deletedIndex){
      this.variable.references = this.variable.references
        .filter((items,index) => index != deletedIndex);
    },
    async addIndicatorReference(){
      if(this.indicator.references.length>0){
        let valid = await this.$refs.indicatorReferencesObserver.validate();
        if(valid){
          this.indicator.references.push('');
        }
      }
      else{
        this.indicator.references.push('');
      }
    },
    deleteIndicatorReference(deletedIndex){
      this.indicator.references = this.indicator.references
        .filter((items,index) => index != deletedIndex);
    },
    //utility function
    handlePageChange(){
      this.getSdsnList();        
    },
    listFormatter(value){
      if(value){
        let formattedList = '<div class="text-left">';
        value.split(';').forEach((item,index) => {
          formattedList = formattedList + '<div class="d-flex"><div>'+(index+1)+'.&nbsp;</div><div>'+item+'</div></div>';
        });
        return formattedList + '</div>';
      }else{
        return '-';
      }
    },
    dateFormatter(stringDate){
      moment.locale("id");
      return moment(stringDate).format('LL');
    },
    statusFormatter(status){
      return status ? this.options.status.find(x=>x.value == status).label : 'Draft';
    },
    statusFormatterStyle(status){
      return status ? status.split('_')[0].toLowerCase() : 'draft';
    },
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    async produsenDataLoadOptions({searchQuery, callback}){
      let name = searchQuery;
      let page = 0;
      let provinceCode = this.provinceCode ? this.provinceCode : null ;
      let cityCode = this.cityCode ? this.cityCode : null ;
      await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode).then(
         (result)=>{
            let options = result.data.content;
            callback(null, options)
         },
         (error)=>{
            console.log(error)
         }
      );
    },
    async conceptReferenceLoadOptions({searchQuery, callback}){
      let query = "name="+searchQuery+'&sdsType=CONCEPT&page=0&size=20';
      await sdsService.getSdsItemListByQuery(query).then(
        (result) => {
            let options = result.data.content;
            callback(null, options)
        },
        (error) => {
            this.error=error;
        }
      );
    },
    async variableReferenceLoadOptions({searchQuery, callback}){
      let query = "name="+searchQuery+'&sdsType=VARIABLE&page=0&size=20';
      await sdsService.getSdsItemListByQuery(query).then(
        (result) => {
            let options = result.data.content;
            callback(null, options)
        },
        (error) => {
            this.error=error;
        }
      );
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    provinceNormalizer(node){
      return {
        id: node.code,
        label: node.name,
      }
    },
    cityNormalizer(node){
      return {
         id: node.kode,
         label: node.nama,
      }
    },
    produsenDataNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
      }
    },
    conceptNormalizer(node) {
      return {
        id: node.id != null ? node.id : node.submission_id ,
        label: node.name,
      }
    },
    variableNormalizer(node) {
      return {
        id: node.id != null ? node.id : node.submission_id ,
        label: node.name,
      }
    },
    itemExist(name, objectArray){
      if(objectArray != null){
        let existItem = objectArray.filter(x => x.name == name);
        return existItem.length>0 ? true:false;
      }
      else{
        return false
      }
    },
    rejectedStatusTypeFormatter(status){
      return status && this.options.rejected_status_type.find(x=>x.id == status) ? this.options.rejected_status_type.find(x=>x.id == status).label : '-';
    },
    
    produsenDataChanged(){
      let x =  this.produsenData
      this.form.produsen_data = {
        id: x.id,
        name: x.name,
        province_code: x.provinceCode,
        city_code :x.cityCode,
      }
      let walidata = x.details.walidata;
      this.form.walidata_pusat = walidata
    },
    variableConceptsChanged(){
      this.variable.concepts = this.variableConcepts.map(x=>{
        return {id:x.id,name:x.name}
      })
    },
    indicatorConceptsChanged(){
      this.indicator.concepts = this.indicatorConcepts.map(x=>{
        return {id:x.id,name:x.name}
      })
    },
    indicatorDisaggregationsChanged(){
      this.indicator.disaggregations = this.indicatorDisaggregations.map(x=>{
        return {id:x.id,name:x.name}
      })
    },

    prev(){
      if(this.section.currentIndex != 0) {this.section.currentIndex-=1}
    },
    async next(){
      let valid = await this.$refs.section1Observer.validate();
      if(valid && this.section.currentIndex != this.section.items.length-1) {
        this.section.items[this.section.currentIndex].status = 'valid'
        this.section.currentIndex+=1;
      }
      else{
        this.section.items[this.section.currentIndex].status = 'invalid'
      }
        
    },
    setInitialRightPanel(){
      if(this.form.submission_type == 'UPDATE'){
          this.updatedSdsnVisible = true
      }
    },
    isRejected(status){
      if(['REJECTED_KABKOTA','REJECTED_PROVINSI','REJECTED_PUSAT'].includes(status)){
        return true;
      }else{
        return false;
      }
    },
    async showConceptReference(id){
      this.modal.conceptReference = null;
      this.modal.alternativeConceptReference = null;
      this.modal.variableReference = null;
      this.modal.alternativeVariableReference = null;
      this.modal.isLoading = true;
      this.$bvModal.show('modal-detail-reference');
      let sdsItem = null;
      await sdsService.getSdsItem(id).then(
        async (result)=>{
          sdsItem = {...result.data.result[0]};
          if(sdsItem.sds_type == 'CONCEPT'){
            sdsItem.data.concept = sdsItem.submissionPeriod > 2022 ? sdsItem.data.concept : this.updateConceptStructure(sdsItem.data.concept, sdsItem.submission_type);
            this.modal.conceptReference = sdsItem;
          }
          if(sdsItem.sds_type == 'VARIABLE'){
            sdsItem.data.variable = sdsItem.submissionPeriod > 2022 ? sdsItem.data.variable : this.updateVariableStructure(sdsItem.data.variable, sdsItem.submission_type);
            sdsItem.data.variable.concepts = await this.syncConceptVar(sdsItem);
            this.modal.variableReference = sdsItem;
          }
        },
        (error)=>{
          console.log(error);
        }
      );
      if(this.isRejected(sdsItem.status) && sdsItem.alternative_sds_item_id ){
        await sdsService.getSdsItem(sdsItem.alternative_sds_item_id ).then(
          async (result)=>{
            let sdsItem = {...result.data.result[0]};
            if(sdsItem.sds_type == 'CONCEPT'){
              sdsItem.data.concept = sdsItem.submissionPeriod > 2022 ? sdsItem.data.concept : this.updateConceptStructure(sdsItem.data.concept, sdsItem.submission_type);
              this.modal.alternativeConceptReference = sdsItem;
            }
            if(sdsItem.sds_type == 'VARIABLE'){
              sdsItem.data.variable = sdsItem.submissionPeriod > 2022 ? sdsItem.data.variable : this.updateVariableStructure(sdsItem.data.variable, sdsItem.submission_type);
              sdsItem.data.variable.concepts = await this.syncConceptVar(sdsItem);
              this.modal.alternativeVariableReference = sdsItem;
            }
          },
          (error)=>{
            console.log(error);
          }
        );
      }
      this.modal.isLoading = false;
    },
    useAlternativeReference(){
      if(this.modal.alternativeConceptReference){
        if(this.form.sds_type == 'VARIABLE'){
          this.variableConcepts.splice(this.variableConcepts.map(x=>x.id).indexOf(this.modal.conceptReference.id),1);
          this.variableConcepts.push(this.modal.alternativeConceptReference);
          this.variableConcepts = lodash.uniqBy(this.variableConcepts, 'id');
        }
        if(this.form.sds_type == 'INDICATOR'){
          this.indicatorConcepts.splice(this.indicatorConcepts.map(x=>x.id).indexOf(this.modal.conceptReference.id),1);
          this.indicatorConcepts.push(this.modal.alternativeConceptReference);
          this.indicatorConcepts = lodash.uniqBy(this.indicatorConcepts, 'id');
        }
      }
      if(this.modal.alternativeVariableReference){
        this.indicatorDisaggregations.splice(this.indicatorDisaggregations.map(x=>x.id).indexOf(this.modal.variableReference.id),1);
        this.indicatorDisaggregations.push(this.modal.alternativeVariableReference);
        this.indicatorDisaggregations = lodash.uniqBy(this.indicatorDisaggregations, 'id');
      }
      this.$bvModal.hide('modal-detail-reference');
      this.$forceUpdate();
    },
    async syncConceptVar(sdsItem){
      let concepts = [...sdsItem.data.variable.concepts];
      let newConcepts = await Promise.all(concepts.map(async (item) => {
          let concept = null;
          if(sdsItem.submission_period==2022 && item.submission_id ){
            let id = item.submission_id;
            await sdsService.getOldSdsItem(id).then(
              (result)=>{
                concept = {...result.data.result[0]};
                concept.definition = concept.data.concept.definition;
                concept.source = 'USULAN';
                
              },
              (error)=>{
                console.log(error);
              }
            );
          }else{
            await sdsService.getSdsItem(item.id).then(
              (result)=>{
                concept = {...result.data.result[0]};
                concept.definition = concept.data.concept.definition;
                concept.source = 'USULAN';
                
              },
              (error)=>{
                console.log(error);
              }
            );
          }
          return concept;
      }));  
      return newConcepts;
    },
    maxValue(array){
      return lodash.max(array);
    },
    updateConceptStructure(concept,submissionType){
      let newConcept = {
        code: concept.code,
        name: concept.name,
        definition: concept.definition,
        references: concept.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_concept: null,
      }
      if(submissionType == 'UPDATE'){
        newConcept.updated_concept = {
          changes_type : 'MODIFY', 
          items: []
        }
        if('updated_concept' in concept){
          newConcept.updated_concept = concept.updated_concept;
        }else{
          let newUpdatedConcept = concept.current_version;
          newUpdatedConcept.references = newUpdatedConcept.references.map(x=>x.name),
          
          newConcept.updated_concept = {
            changes_type : 'MODIFY', 
            items: [newUpdatedConcept]
          }
        }
      }
      return newConcept;
    },
    updateVariableStructure(variable,submissionType){
      // let submissionType = sdsItem.submission_type;
      // let variable = sdsItem.data.variable;
      // console.log(variable)
      let newVariable = {
        code: variable.code,
        name: variable.name,
        definition: variable.definition,
        concepts: ('concept' in variable) ? variable.concept : variable.concepts, //update with actual state,
        unit_types: variable.unit_types, //change format json
        measurement: variable.measurement, //change format json
        measurement_unit: variable.measurement_unit, //change format json,
        subject_field: variable.subject_field, //change format json,
        value_domain: variable.value_domain, //change format json
        rule: variable.rule,
        references: variable.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_variable: null,
      }
      if(submissionType == 'UPDATE'){
        if('updated_variable' in variable){
          newVariable.updated_variable = variable.updated_variable;
        }else{
          let newUpdatedVariable = variable.current_version;
          newUpdatedVariable.references = newUpdatedVariable.references.map(x=>typeof x == 'string' ? x : x.name);
          let newValueDomain  = {
            type: null,// change use current format
            classification_reference: null,
            items:[],
            total_levels:0
          }
          if('classification' in newUpdatedVariable.value_domain){
            newValueDomain.items = newUpdatedVariable.value_domain.classification.items;
          }else{
            newValueDomain.items = newUpdatedVariable.value_domain.items;
          }
          newUpdatedVariable.value_domain = newValueDomain;

          newVariable.updated_variable = {
            changes_type : 'MODIFY', 
            items: [newUpdatedVariable]
          }
        }

      }
      //change format json for unit types 
      if(newVariable.unit_types != null & newVariable.unit_types.length>0){
        newVariable.unit_types = newVariable.unit_types.filter(x=>x!=null).map(item => {
          if(item.id == null){
            let _newUnitTypes = {
              id:null,
              name:item.name,
              description:null,
            };
            return _newUnitTypes;
          }else{
            return this.options.unit_type.find(x => x.id == item.id);
          }        
        });
      }
      //change format json for measurement 
      if(newVariable.measurement){
        if(newVariable.measurement.id == null){
          let newMeasurement = {
            id:null,
            name:newVariable.measurement.name,
            description:null,
          };
          newVariable.measurement = newMeasurement;
        }else{
          newVariable.measurement = this.measurements.find(x => x.id == newVariable.measurement.id);
        }
      }
      //change format json for measurement unit
      if(newVariable.measurement_unit){
        if(newVariable.measurement_unit.id == null){
          let newMeasurementUnit = {
            id: null,
            name: newVariable.measurement_unit.name,
            symbol: null
          }
          newVariable.measurement_unit = newMeasurementUnit;
        }
        // else{
        //   newVariable.measurement_unit = this.variableMeasurementUnits.find(x => x.id == newVariable.measurement_unit.id);
        // }
      }
      //change format json for subject_field
      if(newVariable.subject_field){
        let subjects =  [...SubjectField]
        newVariable.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newVariable.subject_field.id);
      }
      //change format json for value domain
      // console.log(newVariable.value_domain)
      if(newVariable.value_domain){
        let newValueDomain  = {
          type: null,// change use current format
          classification_reference: null,
          items:[],
          total_levels:0
        }
        if(newVariable.value_domain.type && newVariable.value_domain.type.id != null){
          newValueDomain.type = this.options.value_domain_type.map(x=> x.value).find(x => x.id == newVariable.value_domain.type.id);
          if(newValueDomain.type.id == 76){
            if('classification' in newVariable.value_domain){
              newValueDomain.classification_reference = newVariable.value_domain.classification.id ? {
                id: newVariable.value_domain.classification.id,
                name: newVariable.value_domain.classification.name,
                description: null,
                used_type: newVariable.value_domain.classification.items.length>0 ? 'PARTIAL' : 'FULL',
              } : null;
              newValueDomain.items = newVariable.value_domain.classification.items;
            }else{
              newValueDomain.classification_reference = newVariable.value_domain.classification_reference;
              newValueDomain.items = newVariable.value_domain.items;
            }

            if(newValueDomain.classification_reference){
              //update classification reference
              this.classificationReferenceId = newValueDomain.classification_reference.id;
              this.classificationReferenceUsedType = newValueDomain.classification_reference.used_type;
            }
          }
        }
        newVariable.value_domain = newValueDomain;
      }
      return newVariable;
    },
  },
  
}
</script>
